import React, { useEffect, useCallback, useRef } from "react";
import p_nav_previous from "../../Assets/Images/p_nav_previous.svg";
import porter_logo from "../../Assets/Images/porter_logo.png"
import { useLocation, useNavigate } from "react-router-dom";
import { MdKeyboardArrowDown } from "react-icons/md";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { LiaPlusCircleSolid } from "react-icons/lia";
import { FiMinusCircle } from "react-icons/fi";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { useState } from "react";
import { SlArrowDown } from "react-icons/sl";
import { SlArrowUp } from "react-icons/sl";
import axiosInstance, { Razorpay_Key, environment, baseURL } from "../../Services/axios";
import { IoIosArrowForward } from "react-icons/io";
import { MdWork } from "react-icons/md";
import { IoMdHome } from "react-icons/io";
import { IoLocationSharp } from "react-icons/io5";
// import { MdOutlineCheckCircle } from "react-icons/md";
import { IoMdCheckmarkCircle } from "react-icons/io";
import { MdOutlineRadioButtonUnchecked } from "react-icons/md";
import defaultimg from "../../Assets/Images/default-placeholder.png";
import useRazorpay from "react-razorpay";
import { useUser } from "../../Components/UserContext";
import { getDatabase, ref, onValue, Database } from "firebase/database";
import Lottie from "lottie-react";
import SuccessLotie from "./../../Assets/lottieFiles/success.json";
import defaultproductimg from "../../Assets/Images/default-placeholder.png";
import { CgCloseO } from "react-icons/cg";
import { toast } from "react-toastify";
import { FaRegSquarePlus, FaCircleCheck } from "react-icons/fa6";
import ReactLoading from "react-loading";
import DeliveryTime_Slot from "../../Components/DeliveryTImeslot/DelivrySlot";
import { FaRupeeSign } from "react-icons/fa";
import tick_icon from "../../Assets/Images/icons/tick_icon.png"
import { IoChevronBack } from "react-icons/io5";


// Menu
import vegIcon from "../../Assets/Images/vegpngoutput.png"
import eggIcon from "../../Assets/Images/eggpngoutput.png"
import nonvegIcon from "../../Assets/Images/nomvegoutput.png"

// Addon
import { IoMdClose } from "react-icons/io";
import { MdArrowForwardIos } from "react-icons/md";

// coupon
import apply_coupon from "../../Assets/Images/icons/apply_coupon.png"
import { RiEBikeFill } from "react-icons/ri";
import select_circle from "../../Assets/Images/icons/select_rectangle.png"
import unselect_circle from "../../Assets/Images/icons/unselect_rectangle.png"
import bell_icon from "../../Assets/Images/icons/bell_icon.png"
import door_icon from "../../Assets/Images/icons/door_icon.png"
import Avoid_call from "../../Assets/Images/icons/avoid_call_icon.png"
import gurard_icon from "../../Assets/Images/icons/guard_icon.png"
import pet_foot from "../../Assets/Images/icons/pet_foot_icon.png"
import { FaIndianRupeeSign } from "react-icons/fa6";
import success_audio from "../../Assets/Audios/success.mp3"
import { AudioRecorder, useAudioRecorder } from 'react-audio-voice-recorder';
import { FaPlay } from "react-icons/fa";
import { FaPause, FaStop } from "react-icons/fa6";
import { MdDeleteOutline } from "react-icons/md";
import { FFmpeg } from '@ffmpeg/ffmpeg';
import { CgClose } from "react-icons/cg";
import { FaRegSquare, FaSquareCheck } from "react-icons/fa6";

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { showToast } from "../../Components/toastConfig/ToastConfig";
import InstructionsNoteModal from "../../Components/Instructions_Note/InstructionsNoteModal";
import { useSelector } from "react-redux";
import { FaPlus } from "react-icons/fa6";
import { FaMinus } from "react-icons/fa";
import { TfiPencil } from "react-icons/tfi";
import { addOrRemoveProductCart, getProductCheckoutDetails, getProductDeliveryStaffDetails, getUserOrderLocationList, getVendorProfileDetails, productAssignOrder, productChangeCartShippingType, productConfirmCancelOrder, productConfirmEditOrder, productConfirmOrder, productConfirmPayment, productConfirmReassignOrder, productRedeemVendorLoyaltyOrder, productUpdateDeliveryTimeDate, selectDeliveryLocation } from "../../Services/api";
import NodeaxiosInstance from "../../Services/nodeaxios";



const ReviewPay = () => {

  const [Razorpay] = useRazorpay();
  const currentUser = useUser(); // Access user context
  const state = useSelector((state) => state);
  const [userData, serUserData] = useState(state?.userAuth?.user);

  const paymentSuccessModalRef = useRef(null);
  const orderSuccessModalRef = useRef(null);
  const locationModalRef = useRef(null);
  const cancelOrderModalRef = useRef(null);
  const deliveryOptionRef = useRef(null)
  const slotdeliveryModalRef = useRef(null)
  const instructionsNoteRef = useRef(null)
  const courierModelRef = useRef(null)

  const navigate = useNavigate();
  const location = useLocation();
  const { merchantId, flow, offerCartId, flowtype, offerLoyaltyPoints, cart_id, orderType, fromPage } = location.state || {};


  const [errors, setErrors] = useState({})
  const [showContent, setShowContent] = useState(false);
  const [productDetail, setProductDetail] = useState([]);
  const [productlist, setProductlist] = useState([]);
  const [shipingtype, setShipingtype] = useState("");
  const [userLocation, setUserLocation] = useState([]);
  const [confirmlocation, setConfirmlocation] = useState();
  const [userlatlong, setUserlatlong] = useState([]);
  const [paymenttype, setPaymenttype] = useState([]);
  const [selectpaytype, setSelectPaytype] = useState(1);
  const [otherdeliverytype, setOtherdeliverytype] = useState('0');
  const [gststatus, setGststatus] = useState(true);
  const [deliverylocation, setDeliverylocation] = useState([]);
  const [consulation, setConsulation] = useState("");
  const [deleteitem, setDeleteitem] = useState();
  const [animationSrc, setAnimationSrc] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [cartId, setCartId] = useState("");
  const [vendorId, setVendorId] = useState("");
  const [pageLoaded, setPageLoaded] = useState(false);
  const [buyproduct, setBuyproduct] = useState([]);
  const [getproduct, setGetproduct] = useState([]);
  const [offerDetails, setOfferDetails] = useState();
  const [offertype, setOffertype] = useState();
  const [userId, setUserId] = useState();
  const [paymentOrderId, setPaymentOrderId] = useState();
  const [initiateTime, setInitiateTime] = useState("");
  const [loyaltyOfferid, setLoyaltyOfferid] = useState('')
  const [loyaltyOfferDetails, setLoyaltyOfferDetails] = useState('')

  const [locationBtnloder, setLocationBtnloder] = useState(true);
  const [slotTime, setSlotTime] = useState('')
  const [deliveryDate, setDeliveryDate] = useState('')
  const [deliveryModelStatus, setDeliveryModelStatus] = useState(false)
  const [cardStatus, setCardStatus] = useState();
  const [cardType, setcardType] = useState();
  const [cardId, setcardId] = useState();
  const [showaddons, setShowaddons] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false)
  const addonModalRef = useRef(null);
  const addonEditeModalRef = useRef(null);

  const [productid, setProductid] = useState('')
  const [productCost, setProductCost] = useState('')
  const [addonsCost, setAddonsCost] = useState('')
  const [selectedAddons, setSelectedAddons] = useState('')
  const [productCount, setProductCount] = useState(0)
  const [addonModel, setAddonModel] = useState(false);
  const [razorpayOrderId, setRazorpayOrderId] = useState("");
  const [deliverystaffAccept, setDeliverystaffAccept] = useState("0")
  const [orderId, setOrderId] = useState("");
  const [pilotAcceptStatus, setPilotAcceptStatus] = useState("0")
  const [deliverypartnerDetails, setDeliverypartnerDetailse] = useState("")
  const [instantDelivery, setInstantDelivery] = useState(false)
  const [timeChangeType, setTimeChangeType] = useState(false)
  const [selectItem, setSelectItem] = useState('')
  const [showDatePickerModal, setDatePickerModal] = useState(false);
  const [isDatePickerOffCanvasOpen, setDatePickerOffCanvasOpen] = useState(false);

  const [change_AddressModal, setChange_AddressModal] = useState(true);
  const [menuStatus, setMenuStatus] = useState('');

  const [delivery_option, setDelivery_option] = useState(1)
  const [deliverytype, setDeliverytype] = useState('');
  const [otherdeliveryoption, setOtherdeliveryoption] = useState(false);
  const [tipOption, setTipOption] = useState()
  const [deliverytipamt, setDeliveryTipamt] = useState('')
  const [instructionsOption, setInstructionsOption] = useState([])


  const [showAdditionalCookingNotes, setShowAdditionalCookingNotes] = useState(false);
  const [additionalCookingNotes, setAdditionalCookingNotes] = useState("");
  const [confirmAdditionalCookingNotes, setConfirmAdditionalCookingNotes] = useState("");

  const [restart_Modal, setRestart_Modal] = useState(false)
  const [vendorType, setVendorType] = useState()
  const [selectedTexts, setSelectedTexts] = useState("")
  const [availableCourierList, setAvailableCourierList] = useState([]);
  const [recomendedCourier, setRecomendedCourier] = useState();
  const [selectedCourierDelivery, setSelectedCourierDelivery] = useState();
  const [instructionisLoading, setInstructionIsLoading] = useState(false);
  const [showInstructionModal, setShowInstructionModal] = useState('');

  let check = localStorage.getItem("login");



  const flowtypeValue = flowtype == "EDIT_ORDER" ? "EDIT_ORDER" : flowtype;

  const paymentAudio = new Audio(success_audio);
  const [modalOpen, setModalOpen] = useState(false);

  const DEFAULT_Ticket_IMAGE_URL = "https://theme-assets.getbento.com/sensei/6941e9b.sensei/assets/images/catering-item-placeholder-704x520.png";
  const DEFAULT_IMAGE_URL = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcScO99JkPvdfSyT3CbMrYsKBpRuXOACVR2cP9F6DBcP9B6nQ9oszX_18T-2oNv6Gyxwyhk&usqp=CAU";
  useEffect(() => {

    const fetchData = async () => {
      let productCart = localStorage.getItem("productCart") ? JSON.parse(localStorage.getItem("productCart")) : "";

      setCartId(productCart?.cartId);
      setVendorId(productCart?.vendorId ? productCart?.vendorId : "");
      setShipingtype(productCart?.shipping_type ? productCart?.shipping_type : "");

      setLoyaltyOfferid(productCart?.loyaltyDetail?.offer_id ? productCart?.loyaltyDetail?.offer_id : "")
      setLoyaltyOfferDetails(productCart?.loyaltyDetail ? productCart?.loyaltyDetail : '')
      let vendortype = localStorage.getItem("vendortype") ? JSON.parse(localStorage.getItem("vendortype")) : "";
      setMenuStatus(vendortype?.vendor_type ? vendortype?.vendor_type : "")
      let appliedCard = JSON.parse(localStorage.getItem("appliedCard"));
      setCardStatus(appliedCard?.cardStatus ? appliedCard?.cardStatus : "");
      setcardType(appliedCard?.cardType ? appliedCard?.cardType : "");
      setcardId(appliedCard?.cardId ? appliedCard?.cardId : "");

      let SelectedPaytype = localStorage.getItem('seletedPayType')
      setSelectPaytype(SelectedPaytype ? SelectedPaytype : 1)

    };

    fetchData();
    if (userData?.user_type == "User") {
      getVendorStatuses()
    }
  }, [cartId, vendorId, shipingtype, loyaltyOfferid]);


  useEffect(() => {
    const savedOptions = JSON.parse(localStorage.getItem("deliveryInstructions")) || [];
    const additionalNotes = localStorage.getItem("additionalNotes") || "";

    setInstructionsOption(savedOptions);
    setSelectedTexts(savedOptions);
    setConsulation(additionalNotes)
  }, []);


  useEffect(() => {
    if (flowtype) {
      let EditCart = localStorage.getItem("EditOrder_Detail") ? JSON.parse(localStorage.getItem("EditOrder_Detail")) : "";
      if (EditCart) {
        setCartId(EditCart?.orderid ? EditCart?.orderid : "");
        setShipingtype(EditCart?.shippingtype ? EditCart?.shippingtype : "");
        setVendorId(EditCart?.vendorId ? EditCart?.vendorId : "");
      }
    }
  }, [flowtype]);


  useEffect(() => {

    const fetchDatas = async () => {
      if (cartId != "" && String(cartId).length > 0) {
        getselectProductDetail();


      }
    };

    fetchDatas();
    let initiateTimes = formatDateToCustomFormatWithTimeZone(
      new Date(),
      "Asia/Kolkata"
    );
    setInitiateTime(initiateTimes);

  }, [cartId, flow, offerCartId]);



  useEffect(() => {
    if (!currentUser) return; // Check if user is not logged in
    const database = getDatabase();
    const orderRef = ref(database, `/payments/product_order/${userId}`);
    const unsubscribe = onValue(orderRef, (snapshot) => {
      const data = snapshot.val();

      if (data.status == 2 && data.order_id == paymentOrderId) {

        const productOrderId = data.product_order_id;
        openPaymentSuccessModal();
        if (productOrderId) {
          const productOrderId = data.product_order_id;
          openPaymentSuccessModal();
          if (productOrderId) {
            setOrderId(productOrderId);
            if (productOrderId) {
              AssignOrder(productOrderId);
            }
            setPilotAcceptStatus(1);
          }
        }
        // setPageLoaded(true);

      }
    });
    return () => unsubscribe();
  }, [paymentOrderId]);

  useEffect(() => {
    const fetchAnimationData = async () => {
      try {
        const response = await fetch(
          "https://lottie.host/24705db4-5a9c-4d93-9c1b-217adf1bf628/z8KgTNPh81.json"
        );
        const animationData = await response.json();
        setAnimationSrc(animationData);
      } catch (error) {
        console.error("Error fetching animation data:", error);
      }
    };

    fetchAnimationData();
  }, []);


  useEffect(() => {
    const database = getDatabase();
    if (razorpayOrderId && pilotAcceptStatus != '2') {
      const orderRef = ref(database, `/payments/product_order/${productDetail?.user_id}`);
      const unsubscribe = onValue(orderRef, (snapshot) => {
        if (snapshot.val() != null) {
          const productOrderId = snapshot.val().product_order_id
          setOrderId(productOrderId)
          if (snapshot.val().order_id == razorpayOrderId) {
            if (productOrderId) {
              AssignOrder(productOrderId);
            }
            setDeliverystaffAccept('1');
          } else if (snapshot.val().status == 3) {
            setPilotAcceptStatus(2);
          }
          else {
          }
        }
      });
    }
  }, [razorpayOrderId]);

  useEffect(() => {

    const database = getDatabase();
    if (orderId) {
      const orderRef = ref(database, `/instant_delivery/${orderId}`);
      const unsubscribe = onValue(orderRef, (snapshot) => {


        if (snapshot.val() != null) {
          if (snapshot.val() == 3) {
            setDeliverystaffAccept('1');
            if (orderId) {
              AssignOrder(orderId);
            }
          } else if (snapshot.val() == 2) {
            deliveryStaffDetails()
            setDeliverystaffAccept('2');
          } else {

          }
        }
      });

      return () => unsubscribe();

    }
  }, [orderId]);

  const handleOptionToggle = (label) => {
    setInstructionsOption((prevOptions) => {
      const updatedOptions = prevOptions.includes(label)
        ? prevOptions.filter((option) => option !== label)
        : [...prevOptions, label];

      // Save to localStorage
      localStorage.setItem("deliveryInstructions", JSON.stringify(updatedOptions));

      return updatedOptions;
    });
    setSelectedTexts((prevOptions) =>
      prevOptions.includes(label)
        ? prevOptions.filter((option) => option !== label)
        : [...prevOptions, label]
    );
    // localStorage.setItem("deliveryInstructions", JSON.stringify(instructionsOption));
  };


  useEffect(() => {
    const interval = setInterval(() => {
      setRestart_Modal(true);
    }, 60000);

    return () => clearInterval(interval);
  }, [orderId]);

  const AssignOrder = async (productOrderId) => {
    try {
      let data = {
        order_id: productOrderId,
        vendor_id: vendorId,
      };

      let res = await productAssignOrder(data);
      if (res.data.status == "3") {
        setDeliverystaffAccept("3")
      }
    }
    catch (err) {
      if (err.response.status == 400 || err.response.status == 500) {
        showToast(err.response?.data?.message || "Something went wrong, please try again later", "error");
      }
    }
  }



  const deliveryStaffDetails = async () => {
    let data = {
      order_id: orderId
    };

    try {
      let res = await getProductDeliveryStaffDetails(data);
      if (res.status == 200) {
        setDeliverypartnerDetailse(res.data.delivery_staff_detail);
        setDeliverystaffAccept("1");
      }
    } catch (err) {
      if (err.response.status == 400 || err.response.status == 500) {
        showToast(err.response?.data?.message || "Something went wrong, please try again later");
      }
    }
  };

  const cancelConfirmedOrder = async () => {

    let data = {
      order_id: orderId,
    };

    try {
      let res = await productConfirmCancelOrder(data);
      if (res?.status == 200) {
        handleOkClick()
        closecancelOrderModal()
      }
    } catch (err) {
      if (err.response.status == 500 || err.response.status == 400) {
        showToast(err.response?.data?.message || "Something went wrong, please try again later");
      }
    }
  };

  const ChooseSlotDelivery = () => {
    let data = {
      order_id: orderId,
      order_delivery_time: "",
      order_delivery_date: "ANY",
    };
    try {
      productUpdateDeliveryTimeDate(data)
        .then((res) => {
          if (res.status == 200) {
            handleOkClick()
          }
        })
        .catch((err) => {
          if (err.response.status == 500 || err.response.status == 400) {
            showToast(err.response?.data?.message || "Something went wrong, please try again later");
          }
        })
    } catch (err) {
      if (err.response.status == 500 || err.response.status == 400) {
        showToast(err.response?.data?.message || "Something went wrong, please try again later");
      }
    }



  };


  const toggleContent = () => {
    setShowContent(!showContent);
  };

  const toggleshowInstruction = () => {
    setConsulation(localStorage.getItem("additionalNotes") || "");
    setShowInstructionModal(!showInstructionModal);
  };

  const toggle_otherDelivery_option = () => {
    setOtherdeliveryoption(!otherdeliveryoption);
  };

  const selectPaymentType = (type) => {
    localStorage.setItem('seletedPayType', type)
    setSelectPaytype(type)
  }

  const handleOkClick = (type) => {

    if (selectpaytype == 3) {
      navigate(`/ProductPass/${orderId}`, { replace: true, state: { orderid: orderId, fromPage: "ReviewPay" } })
    } else {
      if (type == "loyalty&cashafter") {
        navigate(`/ProductPass/${orderId}`, { replace: true, state: { orderid: orderId, fromPage: "ReviewPay" } })

      } else {
        navigate(`/ProductPass/${orderId}`, { replace: true, state: { orderid: orderId, fromPage: "ReviewPay" } })
      }
    }
    setShowModal(false);

    ["serviceDetail", "serviceAdded", "EditOrder_Detail", "localStorageserviceTime",
      "shipping_type", "cartid", "appliedCard",
      "cart_items", "productCart", "additionalNotes", "audioDuration",
      "deliveryInstructions", "recordedAudio", "recordedAudioUrl", "recoredURL"
    ].forEach((key) => localStorage.removeItem(key));

    sessionStorage.removeItem("membership");

  };


  const formatDateToCustomFormatWithTimeZone = (isoDate, timeZone) => {
    const date = new Date(isoDate);

    const timeOptions = {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone,
    };
    const formattedTime = date.toLocaleString("en-US", timeOptions);

    const weekday = date.toLocaleString("en-US", { weekday: "short", timeZone });

    const day = date.getDate();
    const daySuffix = getDaySuffix(day);

    const month = date.toLocaleString("en-US", { month: "short", timeZone });

    const year = date.getFullYear();

    return `at ${formattedTime} on ${weekday} ${day}${daySuffix} ${month} ${year}`;
  };

  // helper for suffix
  const getDaySuffix = (day) => {
    if (day > 3 && day < 21) return "th";
    switch (day % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  };



  const ChangeSlotType = () => {
    if (flowtype != "EDIT_ORDER") {
      setTimeChangeType(true)
      setDeliveryModelStatus(false)
      openDeliveryoptionModal();
    }
  }

  const getselectProductDetail = async () => {

    if (!vendorId) return;

    let reqData = {
      vendor_id: vendorId,
      cart_id: cartId || cart_id,
      flow_type: flowtype == "EDIT_ORDER" ? "EDIT_ORDER" : "ORDER"
    };

    try {
      let response = await getProductCheckoutDetails(reqData);
      console.log('respones--->', response);

      let data = response?.data;
      setProductDetail(data);
      if (data.delivery_slot_type == '3') {
        setInstantDelivery(true)
      }
      setVendorId(data?.vendor_id)

      setPaymenttype(data?.payment_options);
      setProductlist(data?.cart_products);

      setGststatus(data?.gst_status);
      setOfferDetails(data?.offer_detail);
      setBuyproduct(data?.offer_detail?.buy_products);
      setGetproduct(data?.offer_detail?.get_products);
      setOffertype(data?.applied_card_detail?.offer_type);

      // A refetch that comes back without a location has to clear the one on
      // screen, otherwise a stale address stays visible after the cart has
      // dropped it.
      setDeliverylocation(
        data?.delivery_location_status ? data?.delivery_location_address : []
      );
      setShipingtype(data?.shipping_type)

      setPageLoaded(true);

      // Callers that act on the refreshed cart need the data itself: reading
      // productDetail straight after this call gives the state from before it.
      return data;
    }
    catch (err) {
      console.error("Error fetching product checkout details:", err);
      if (err?.response?.data?.status == 4) {
        navigate(-1);
        return;
      }

      if (err?.response?.status == 500 || err?.response?.status == 400) {
        showToast(err?.response?.data?.message || "Something went wrong, please try again later", "error");
      }
    }

  };


  const getuserLocationList = async () => {
    try {
      if (cartId || cart_id);
      let reqData = {
        vendor_id: vendorId,
        cart_id: cartId || cart_id,
      };

      let response = await getUserOrderLocationList(reqData);

      if (response?.status == 200) {
        setUserLocation(response?.data?.user_locations);
        setUserlatlong(response?.data?.latlng);
        openAddLocationModal();
      }
    } catch (err) {
      // Without this the loader stays up and the list never opens, with the
      // reason swallowed by a TypeError on err.response.
      setLocationBtnloder(true);
      setIsModalOpen(false);
      showToast(
        err?.response?.data?.message || "Something went wrong, please try again later",
        "error"
      );
    }
  };

  const select_Location = async (latlng) => {
    try {
      let reqData = { cart_id: cartId || cart_id, location: latlng };

      let res = await selectDeliveryLocation(reqData);
      if (res?.status == 200) {
        closeLocationModal();
        closeLocationlistModal()
        setConfirmlocation(1);
        setErrors({});

        // The cart only carries the new address once this resolves, so the
        // slot prompt has to be driven by what comes back. It used to read
        // productDetail here, which still held the pre-selection cart, so the
        // screen kept showing no delivery address and the pay button kept
        // asking for one.
        const data = await getselectProductDetail();

        setIsModalOpen(false);
        if (data?.delivery_slot_status == 0) {
          openDeliveryoptionModal();
        }
        setChange_AddressModal(false);
      }
    } catch (err) {
      // The API answers 400 with a real reason here - "Order not deliverable
      // for this location" among them - so show it instead of passing the
      // whole axios response to the toast.
      showToast(
        err?.response?.data?.message || "Something went wrong, please try again later",
        "error"
      );
    }
  };

  const confirmOrder = async () => {
    try {
      let reqData = {
        cart_id: cartId,
        payment_method: selectpaytype,
        note_desc: consulation,
        flow_type: flowtype == "EDIT_ORDER" ? "EDIT_ORDER" : "ORDER"
      };
      let response = await productConfirmOrder(reqData);
      if (response.status == 200) {
        setOrderId(response?.data?.order_id)
        openOrderSuccessModal();
        localStorage.removeItem('EditOrder_Detail');
      }
    } catch (err) {
      setIsLoading(false);
      showToast(err.response?.data?.message || "Something went wrong, please try again later", "error");
    }
  };

  function openAddLocationModal() {
    setIsModalOpen(true);

    setTimeout(() => {
      let modal = document.getElementById("selectLocatinModal");
      if (modal) {
        modal.classList.add("show");
      } else {
        console.warn("Modal element not found!");
      }
    }, 0); // Runs after the next render cycle

    setLocationBtnloder(true);
  }

  function closeLocationlistModal() {
    var modal = document.getElementById("selectLocatinModal");

    if (modal) {
      modal.classList.remove("show");
      setLocationBtnloder(true);
      setIsModalOpen(false);
    } else {
      console.warn("Modal element not found!");
    }
  }

  const confirmPayment = async () => {
    try {
      let url = localStorage.getItem('recoredURL')
      let reqData = {
        cart_id: cartId,
        payment_method: flow == 'LoyaltyProduct' ? 4 : selectpaytype,
        note_desc: consulation,
        loyalty_applied: flow == 'LoyaltyProduct' ? 1 : 0,
        delivery_tip: deliverytipamt,
        delivery_instructions: selectedTexts,
        additional_notes: consulation,
        voice_note: url,
        product: confirmAdditionalCookingNotes
      };

      let response = await productConfirmPayment(reqData);
      if (response?.status == 200) {
        let data = response?.data;
        let userDetail = { name: "", phone: "", email: "", };
        setRazorpayOrderId(data?.order?.id)
        if (flow == 'LoyaltyProduct') {
          redeemProductsLoyalty()
        } else {
          if (selectpaytype == 1 || selectpaytype == 2) {
            setPaymentOrderId(data?.order?.id);
            setUserId(data?.user_id);
            userDetail['user_id'] = data?.user_id;

            handlePayment(userDetail, data?.order);
          } else {
            confirmOrder();
          }
        }
      }
    } catch (err) {
      // stop the Pay button spinner as soon as the error (e.g. "<product> out of stock right now") is shown
      setIsLoading(false);
      showToast(err.response?.data?.message || "Something went wrong, please try again later");
    }
  };

  const Add_Remove_productcount = async (productId, Operation) => {
    try {

      const Addition = [];

      if (selectedAddons && selectedAddons.length > 0) {
        selectedAddons.forEach((addon) => {
          Addition.push(...addon.options);
        });
      }


      let reqData = {
        vendor_id: vendorId,
        product_id: productId,
        shipping_type: shipingtype,
        quantity: 1,
        operation: Operation,
        cart_id: cartId,
        card_status: cardStatus,
        card_type: cardType,
        card_id: cardId,
        addons: Addition ? Addition : "",
        flow_type: flowtype == "EDIT_ORDER" ? "EDIT_ORDER" : "ORDER"
      };
      const res = await addOrRemoveProductCart(reqData);

      if (res.status == 200) {
        const cartItemsFromAPI = res?.data?.cart_items || [];

        const updatedCartItems = cartItemsFromAPI.map(item => ({ ...item, price: productCost, }));

        const cart_items = {
          cart_items: updatedCartItems,
          cart_id: res?.data?.cart_id,
          cart_count: updatedCartItems.length,
          sub_total: res?.data?.sub_total,
        };

        localStorage.setItem("cart_items", JSON.stringify(cart_items));
        if (res?.data?.cart_count == "0") {
          let productCart = localStorage.getItem("productCart");

          if (productCart && flowtype != "EDIT_ORDER") {
            let parsedCart = JSON.parse(productCart);
            parsedCart.cartId = "";
            localStorage.setItem("productCart", JSON.stringify(parsedCart));
          }
          localStorage.removeItem('cartid')
          // localStorage.removeItem('appliedCard')
          navigate(`/products/${vendorId}`, { state: { flowtype: flowtype } });
        } else {
          getselectProductDetail();
        }

      }
    } catch (err) {
      if (err.response?.status == 400 || err.response?.status == 500) {
        showToast(err.response.data.message || "Something went wrong. Please try again.");
      }
    }
  };

  const loadingTimeOutButton = () => {
    setIsLoading(true);
    setTimeout(() => { setIsLoading(false); }, 7000);
  }

  const handleConfirmPurchase = () => {
    if (flowtype == flowtypeValue && productDetail?.edit_order_datails?.pay_status == "1") {
      loadingTimeOutButton()
      confirmPayment();
    } else if (flowtype == flowtypeValue && productDetail?.edit_order_datails?.refund_status == "1" ||
      (productDetail?.edit_order_datails?.pay_status == 0 && productDetail?.edit_order_datails?.refund_status == 0)) {
      loadingTimeOutButton()
      confirmEditOrder()
    }
    else {
      loadingTimeOutButton()
      confirmPayment();
    }
  };
  // refund_status
  const deleteProduct = async () => {
    try {
      // Retrieve stored products

      let reqData = {
        vendor_id: vendorId,
        product_id: deleteitem.product_id,
        shipping_type: shipingtype,
        quantity: deleteitem.added_count,
        operation: "remove",
        cart_id: cartId,
        card_status: cardStatus,
        card_type: cardType,
        card_id: cardId,
        flow_type: flowtype == "EDIT_ORDER" ? "EDIT_ORDER" : "ORDER"
      };

      let res = await addOrRemoveProductCart(reqData);
      if (res.data.cart_count == 0) {
        let productCart = localStorage.getItem("productCart");
        if (productCart && flowtype != "EDIT_ORDER") {
          let parsedCart = JSON.parse(productCart);
          parsedCart.cartId = "";
          localStorage.setItem("productCart", JSON.stringify(parsedCart));
        }
        const cartItemsFromAPI = res?.data?.cart_items || [];
        const updatedCartItems = cartItemsFromAPI.map(item => ({ ...item, price: productCost, }));

        const cart_items = {
          cart_items: updatedCartItems,
          cart_id: res?.data?.cart_id,
          cart_count: updatedCartItems.length,
          sub_total: res?.data?.sub_total,
        };
        localStorage.setItem("cart_items", JSON.stringify(cart_items));
        localStorage.removeItem('cartid')
        navigate(`/products/${vendorId}`, { state: { flowtype: flowtype == "EDIT_ORDER" ? flowtype : "" } });
      } else {

        const cartItemsFromAPI = res?.data?.cart_items || [];
        const updatedCartItems = cartItemsFromAPI.map(item => ({ ...item, price: productCost, }));

        const cart_items = {
          cart_items: updatedCartItems,
          cart_id: res?.data?.cart_id,
          cart_count: updatedCartItems.length,
          sub_total: res?.data?.sub_total,
        };
        localStorage.setItem("cart_items", JSON.stringify(cart_items));

        getselectProductDetail();
        closedelectorderModal()
      }

    } catch (err) {
      if (err.response?.status == 400 || err.response?.status == 500) {
        showToast(err.response.data.message || "Something went wrong. Please try again.");
      }
    }
  };

  const redeemProductsLoyalty = async () => {
    try {

      let reqData = {
        "cart_id": cartId,
        "payment_method": '4',
        "offer_id": loyaltyOfferid,
        "loyalty_applied": '1'
      }
      let res = await productRedeemVendorLoyaltyOrder(reqData)
      if (res.status == 200) {
        setOrderId(res.data.order_id)
        openOrderSuccessModal();
      }
    } catch (err) {
      if (err.response?.status == 400 || err.response?.status == 500) {
        showToast(err.response.data.message || "Something went wrong. Please try again.");
      }
    }
  }

  const contactNumber =
    String(productDetail?.user_details?.user_mbl || "")
      .replace(/\D/g, "")
      .slice(-10);



  const handlePayment = useCallback(
    async (userData, orderData, vendorId) => {
      try {
        setPageLoaded(false);

        let origin = "";
        if (environment == "TEST" || environment == "PRODUCTION") {
          origin = `${baseURL}payment-completed?order_id=${orderData.id}&type=productOrder&user_id=${userData?.user_id}`;
        } else {
          origin = `${window.location.origin}/payment-completed?order_id=${orderData.id}&type=productOrder&user_id=${userData?.user_id}`;
        }

        const options = {
          key: Razorpay_Key,
          amount: orderData?.amount,
          currency: orderData?.currency || "INR",
          name: "PINGLE",
          description: "Product Payment",
          image: "https://pingle.in/user/assets/images/LogoUser.png",
          order_id: orderData?.id,

          handler: function (response) {
            window.location.href = origin;
          },
          prefill: {
            name: userData?.name,
            email: userData?.email,
            contact: contactNumber,
          },
          theme: {
            color: "#4E26A3",
          },
          modal: {
            ondismiss: function () {
              setPageLoaded(true);
            },
          }
        };

        const rzp = new window.Razorpay(options);

        rzp.on("payment.failed", function (response) {
          console.error("Payment Failed:", response.error);
          setPageLoaded(true);
        });

        rzp.open();

      } catch (error) {
        console.error("Payment Error:", error);
        setPageLoaded(true);
      }
    },
    [Razorpay_Key, contactNumber]
  );

  const openPaymentSuccessModal = () => {
    // paymentSuccessModalRef.current.classList.add("show");
    // paymentSuccessModalRef.current.style.display = "block";
    setRestart_Modal(false)

    paymentAudio.play().catch((error) => console.error("Error playing audio:", error));

  };

  const closePaymentSuccessModal = () => {
    paymentSuccessModalRef.current.classList.remove("show");
    paymentSuccessModalRef.current.style.display = "none";
  };

  const closecancelOrderModal = () => {
    cancelOrderModalRef.current.classList.remove("show");
    cancelOrderModalRef.current.style.display = "none";
    openPaymentSuccessModal()
  };
  const openOrderSuccessModal = () => {
    orderSuccessModalRef.current.classList.add("show");
    orderSuccessModalRef.current.style.display = "block";
    paymentAudio.play().catch((error) => console.error("Error playing audio:", error));
  };

  const closeLocationModal = () => {
    locationModalRef.current.classList.remove("show");
  };

  const openDeliveryoptionModal = () => {
    if (deliveryOptionRef.current) {
      deliveryOptionRef.current.classList.add("show");
      deliveryOptionRef.current.style.display = "block";
      setIsModalOpen(true)
      setErrors({})
    }
  };


  const closeDeliveryoptionModal = () => {
    deliveryOptionRef.current.classList.remove("show");
    deliveryOptionRef.current.style.display = "none";
    setIsModalOpen(false)
  }

  const opencourierlistModal = () => {
    if (courierModelRef.current) {
      courierModelRef.current.classList.add("show");
      courierModelRef.current.style.display = "block";
      setIsModalOpen(true)
      setDeliverytype()

    }
  };


  const closecourierlistModal = () => {
    courierModelRef.current.classList.remove("show");
    courierModelRef.current.style.display = "none";
    setIsModalOpen(false)
  }

  const opendelectorderModal = () => {
    setModalOpen(true);
    setIsModalOpen(true)
  };

  const closedelectorderModal = () => {
    setModalOpen(false);
    setIsModalOpen(false)
  };

  // slotdeliveryModalRef
  const openslotdeliveryModal = () => {

    slotdeliveryModalRef.current.classList.add("show");
    slotdeliveryModalRef.current.style.display = "block";
    // setDeliveryModelStatus(false)
    setIsModalOpen(true)
  }

  const closeslotdeliveryModal = () => {
    slotdeliveryModalRef.current.classList.remove("show");
    slotdeliveryModalRef.current.style.display = "none";
    setIsModalOpen(false)
    closeDeliveryoptionModal()
  }

  const handleModalBack = () => {
    openDeliveryoptionModal();
    slotdeliveryModalRef.current.classList.remove("show");
    slotdeliveryModalRef.current.style.display = "none";
  };



  const handleLoginNavigate = () => {
    localStorage.setItem("vendorUrl", location.pathname);
    navigate("/login", { state: { fromGuest: true } });
  };

  const toggleDatePickerOffCanvas = () => {
    setDatePickerOffCanvasOpen(!isDatePickerOffCanvasOpen);
    setDatePickerModal(false)
    setIsModalOpen(false)
    ChangeSlotType()
    getselectProductDetail()
    closeDeliveryoptionModal()
    setTimeChangeType(false)

  };

  const handelSelectTime = () => {
    let localServiceDetail = localStorage.getItem("productCart") ? JSON.parse(localStorage.getItem("productCart")) : "";
    if (localServiceDetail != "") {
      // if (localServiceDetail.shipping_type == 2) {
      setDatePickerModal(true)

      setDatePickerOffCanvasOpen(true)
      closeslotdeliveryModal()
      // }
    }
    setTimeChangeType(false)
    setIsModalOpen(true)
  }


  useEffect(() => {

    let localTimeSlot = JSON.parse(localStorage.getItem("productDeliveryTime"))
    setSlotTime(localTimeSlot?.selectHour ? localTimeSlot?.selectHour : "")
    setDeliveryDate(localTimeSlot?.selectDate ? localTimeSlot?.selectDate : "")
    getselectProductDetail()

  }, [isDatePickerOffCanvasOpen, deliveryModelStatus])

  const Select_Delivery_Slot = async (type) => {
    try {

      let reqData = {
        "cart_id": cartId,
        "order_delivery_time": ' ',
        "order_delivery_date": type == "Modal" ? "ANY" : type,
      }

      let res = await productUpdateDeliveryTimeDate(reqData)
      if (res?.status == 200) {
        if (shipingtype == 1) {
          updateInstore(2)
        }

        localStorage.removeItem('productDeliveryTime')
        if (type == "Modal") {
          navigate('/')
        }

        setDeliveryModelStatus(true);
        setTimeChangeType(false)
        closeDeliveryoptionModal()
        // if (type === 'PORTER') {
        //   openporterModall()
        //   GetOtherDeliveryCharges()
        // }
        closeslotdeliveryModal()
        getselectProductDetail()
        setIsModalOpen(false)
      }
    } catch (err) {
      if (err.response.status == 500 || err.response.status == 400) {
        showToast(err.response?.data?.message || "Something went wrong, please try again later");
      }
    }
  }
  const [porter_deliveryCharge, SetPorter_DeliveryCharge] = useState()

  const [latitude, longitude] = deliverylocation?.latlng ? deliverylocation.latlng.split(",") : [null, null];



  const GetOtherDeliveryCharges = () => {

    const data = {

      pickup_lat: productDetail?.vendor_lat,
      pickup_lng: productDetail?.vendor_long,


      drop_lat: latitude,
      drop_lng: longitude,

      cus_name: "felix",

      cus_cntry_code: "+91",
      cus_number: "7678139714",

    }

    NodeaxiosInstance.post("/product/get-porter-data", data)
      .then((res) => {

        if (res.status == 200) {
          SetPorter_DeliveryCharge(res?.data?.porter_delivery_charge);
        }
      })
      .catch((err) => {

        if (err.response.status == 500 || err.response.status == 400) {
          showToast(err.response?.data?.message || "Something went wrong, please try again later");
        }
      });
  };

  const updateInstore = async (type) => {
    let data = {
      cart_id: cartId,
      shipping_type: type
    };
    try {
      let res = await productChangeCartShippingType(data)

      if (res.status == 200) {
        if (type == '2') {
          setLocationApiCalled(false)
        }
        let productCart = {
          shipping_type: type,
          cartId: cartId,
          vendorId: vendorId
        };
        localStorage.setItem("productCart", JSON.stringify(productCart));

        getselectProductDetail()
        closeDeliveryoptionModal()
        closeLocationlistModal()
      }
    } catch (err) {
      if (err.response?.status == 400 || err.response?.status == 500) {
        showToast(err.response.data.message || "Something went wrong. Please try again.");
      }
    }

  };

  const openAddonModal = () => {
    addonModalRef.current.classList.add("show");
    addonModalRef.current.style.display = "block";
    setIsModalOpen(true)

  };
  const closeAddonModal = () => {
    addonModalRef.current.classList.remove("show");
    addonModalRef.current.style.display = "none";
    setIsModalOpen(false)

  };

  const openinstructionsModal = () => {
    instructionsNoteRef.current.classList.add("show");
    instructionsNoteRef.current.style.display = "block";
    setIsModalOpen(true)
  };
  const closeinstructionsModal = () => {
    instructionsNoteRef.current.classList.remove("show");
    instructionsNoteRef.current.style.display = "none";
    setIsModalOpen(false)
    setInstructionIsLoading(false)
  };

  const handelEdittoAddonmodel = () => {
    closeEditAddonModal()
    openAddonModal()
  }
  const transformDataAndCalculateTotalCost = (rawData, selectedOptions) => {
    let transformedData = [];
    let totalCost = 0;

    if (rawData && rawData.length > 0) {
      rawData.forEach((addon) => {
        let addonObj = {
          addonId: addon.id,
          options: []
        };

        addon.options.forEach((option) => {
          if ((selectedOptions || []).some((id) => Number(id) === Number(option.id))) {
            addonObj.options.push(option.id);
            totalCost += Number(option.price) || 0;
          }
        });

        if (addonObj.options.length > 0) {
          transformedData.push(addonObj);
        }
      });
    }

    return { addons: transformedData, cost: totalCost };
  };
  const selectAddon = (addon, option, price) => {
    let addonId = addon.id;
    let selectedAddonsList = [...selectedAddons];
    let found = false;

    selectedAddonsList.forEach(item => {
      if (item.addonId == addonId) {
        found = true;
        if (!item.options.includes(option)) {
          if ((addon.selection_type == 1 && item.options.length > 0) || (addon.selection_type == 2 && Number(addon.max_select) > 0 && item.options.length >= Number(addon.max_select))) {

            toast("You have already selected max addons for this category", {
              position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: 'text-danger toast-style-1'
            });
          } else {
            item.options.push(option);
            setProductCost(Number(productCost) + Number(price));
            setAddonsCost(Number(addonsCost) + Number(price));
          }
        } else {
          item.options = item.options.filter((opt) => opt !== option);
          setProductCost(Number(productCost) - Number(price));
          setAddonsCost(Number(addonsCost) - Number(price));
        }
      }
    });

    if (!found) {
      selectedAddonsList.push({ "addonId": addonId, "options": [option] });
      setProductCost(Number(productCost) + Number(price));
      setAddonsCost(Number(addonsCost) - Number(price));
    }

    setSelectedAddons(selectedAddonsList);
  }

  const checkIsSelectedAddon = (addonId, option) => {
    let selectedAddonsList = [...selectedAddons];
    let found = false;
    selectedAddonsList.forEach(item => {
      if (item.addonId == addonId) {
        if (item.options.includes(option)) {
          found = true;
        }
      }
    });

    return found;
  }

  const checkButtonStatus = () => {

    const selectedObject = productDetail?.cart_products.find(item => item.product_id == productid);

    for (const addon of (selectedObject?.addons || [])) {
      const selectedAddon = selectedAddons.find((sel) => sel.addonId == addon.id);
      const selectedOptionsCount = selectedAddon ? selectedAddon.options.length : 0;

      if (addon?.required == 1 && addon.selection_type == 2 && selectedOptionsCount < Math.max(1, Number(addon.min_select) || 0)) {
        toast(`You need to select at least ${Math.max(1, Number(addon.min_select) || 0)} option(s) from the category ${addon.addon_name}`, {
          position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: 'text-danger toast-style-1 toast-custom-style' // Add your custom class here
        });
        return;
      } else if (addon?.required == 1 && addon.selection_type == 1 && selectedOptionsCount <= 0) {

        toast(`You need to select at least 1 option(s) from the category ${addon.addon_name}`,
          { position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: 'text-danger toast-style-1 toast-custom-style' });

        return;
      }
    }

    closeAddonModal()
    closeEditAddonModal()
    Add_Remove_productcount(productid, "add", "1");
  }

  const openEditAddonModal = (addons, addedAddons, productid, added_count, items) => {
    let transformedData = transformDataAndCalculateTotalCost(addons, addedAddons);


    setSelectedAddons(transformedData.addons);
    setProductid(productid);
    setProductCount(added_count)
    setSelectItem(items)
    setIsModalOpen(true)
    addonEditeModalRef.current.classList.add("show");
    addonEditeModalRef.current.style.display = "block";
    setAddonModel(true)
  };
  const closeEditAddonModal = () => {
    addonEditeModalRef.current.classList.remove("show");
    addonEditeModalRef.current.style.display = "none";
    setIsModalOpen(false)

  };

  const update_Product = async (productId, Operation, count) => {
    try {
      // if (addonstate != "0") {
      let addons = [];
      selectedAddons?.map((addon) => {
        addons = [...addons, ...addon.options];
        // setReqAddon(addons)
      });
      // }
      let reqData = {
        vendor_id: vendorId,
        product_id: productId,
        shipping_type: shipingtype,
        quantity: count,
        operation: Operation,
        cart_id: cartId,
        card_status: cardStatus,
        card_type: cardType,
        card_id: cardId,
        addons: addons,
        flow_type: flowtype == "EDIT_ORDER" ? "EDIT_ORDER" : "ORDER"
      };

      let res = await addOrRemoveProductCart(reqData);
      if (res.status == 200) {
        let cart_items = {
          cart_items: res?.data?.cart_items
        };
        localStorage.setItem("cart_items", JSON.stringify(cart_items));
        getselectProductDetail();
        setSelectedAddons([]);
        closeEditAddonModal()
      }

    } catch (error) {
      toast(`You can't add more than ${productCount} of this product`, { position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: "text-danger toast-style-1", });
    }
  };

  const confirmEditOrder = async () => {
    try {
      let reqData = {
        cart_id: cartId
      }

      let res = await productConfirmEditOrder(reqData);
      if (res?.status == 200) {
        navigate("/")
        localStorage.removeItem('EditOrder_Detail');
      }

    } catch (err) {
      setIsLoading(false);
      showToast(err.response?.data?.message || "Something went wrong. Please try again.");
    }
  };

  const confirmUpdate = () => {
    let ProductItem = productDetail?.cart_products
    var ProductHave = ProductItem?.some((obj) => obj.product_id == productid);
    ProductItem?.map((Cartdata, id) => {

      if (Cartdata.product_id == productid) {
        if (Cartdata.quantity > productCount) {
          update_Product(productid, 'remove', Cartdata.added_count - productCount);
          setAddonModel(false)
        } else if (productCount > Cartdata.added_count) {
          update_Product(productid, 'add', productCount - Cartdata.added_count);
          setAddonModel(false)
        } else {
          setAddonModel(false)
          closeEditAddonModal()

        }
      }
    })

  }

  const [showAddonsState, setShowAddonsState] = useState({});

  const toggleAddon = (index) => {
    setShowAddonsState((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };
  const [locationApiCalled, setLocationApiCalled] = useState(false);

  useEffect(() => {
    if (!locationApiCalled && flowtype != "EDIT_ORDER") {
      if (shipingtype == '2' && productDetail.delivery_location_status == false && userData?.user_type == "User") {
        getuserLocationList();
        setLocationBtnloder(false);
        setLocationApiCalled(true);
      }
    }
  }, [shipingtype]);




  const getVendorStatuses = async () => {
    if (!vendorId) return;

    try {
      let reqData = { vendor_id: vendorId };
      const response = await getVendorProfileDetails(reqData);

      if (response.status == 200) {
        const vendorTypeId = response.data?.vendor_profile?.vendor_details?.vendor_type_id;
        setVendorType(vendorTypeId);
      } else {
        console.warn('Unexpected response status:', response.status);
      }
    } catch (error) {
      console.error('Error fetching vendor details:', error);
    }
  }


  const Reassign_Order_Confirm = async () => {
    setRestart_Modal(false)
    let data = {
      order_id: orderId,
      vendor_id: vendorId,
    };
    try {
      let res = await productConfirmReassignOrder(data);
    } catch (err) {
      if (err.response?.status == 400 || err.response?.status == 500) {
        setRestart_Modal(true)
        showToast(err.response.data.message || "Something went wrong. Please try again.");
      }
    }
  };

  const handleTipSelection = (option, amount) => {
    if (tipOption == option) {
      setTipOption(null);
      setDeliveryTipamt(null);
    } else {
      setTipOption(option);
      setDeliveryTipamt(amount);
    }
  };


  const [recordedAudio, setRecordedAudio] = useState(null);
  const [pauseicon, setPauseicon] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [audioDuration, setAudioDuration] = useState(0);
  const [restartRecord, setRestartRecord] = useState(true);
  const [recordedAudioUrl, setRecordedAudioUrl] = useState(null);
  const [oldrecordedAudioblob, setOldRecordedAudioblob] = useState(null);
  const [recordedDataUrl, setRecordedDataUrl] = useState(null);
  const audioRef = useRef(null);

  const [recordingTime, setRecordingTime] = useState(0);
  const timerRef = useRef(null);

  useEffect(() => {
    if (pauseicon) {
      timerRef.current = setInterval(() => {
        setRecordingTime((prev) => prev + 1);
      }, 1000);
    } else {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }

    return () => clearInterval(timerRef.current);
  }, [pauseicon]);

  const recorderControls = useAudioRecorder(
    {
      noiseSuppression: true,
      echoCancellation: true,
    },
    (err) => console.error(err)
  );

  const addAudioElement = (blob) => {
    if (!blob || (recordedAudio && recordedAudio.size == blob.size)) {
      return;
    }

    if (oldrecordedAudioblob == blob) return;

    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.src = "";
      audioRef.current.onended = null;
      audioRef.current = null;
    }

    setOldRecordedAudioblob(blob);

    if (recordedAudioUrl) {
      URL.revokeObjectURL(recordedAudioUrl);
    }

    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64data = reader.result;

      const newAudioUrl = URL.createObjectURL(blob);

      localStorage.setItem("recordedAudio", base64data);
      localStorage.setItem("recordedAudioUrl", newAudioUrl);
      localStorage.setItem("audioDuration", recordingTime);

      const newAudio = new Audio(newAudioUrl);
      audioRef.current = newAudio;

      newAudio.onended = () => {
        setIsPlaying(false);
      };

      setAudioFile(blob);
      setRecordedAudio(blob);
      setRecordedAudioUrl(newAudioUrl);
      setPauseicon(false);
      setRestartRecord(false);
      setIsPlaying(false);
    };
  };
  useEffect(() => {
    const savedAudio = localStorage.getItem("recordedAudio");
    const storedDuration = localStorage.getItem("audioDuration");

    if (savedAudio) {
      const newAudio = new Audio(savedAudio);
      audioRef.current = newAudio;
      newAudio.onended = () => setIsPlaying(false);
      setRecordingTime(storedDuration);
      setRecordedAudio(savedAudio);
      setRecordedAudioUrl(savedAudio);
      setRestartRecord(false);
      setPauseicon(false);
      setIsPlaying(false);

      newAudio.onloadedmetadata = () => {
        setAudioDuration(newAudio.duration.toFixed(2));
      };
    }
  }, [showInstructionModal]);


  const togglePlayAudio = () => {
    if (!audioRef.current) return;

    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play()
        .catch(e => console.error("Playback failed:", e));
    }
    setIsPlaying(!isPlaying);
  };

  const deleteRecordedAudio = useCallback(() => {

    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.src = "";
      audioRef.current.onended = null;
      audioRef.current = null;
    }

    if (recordedAudioUrl) {
      URL.revokeObjectURL(recordedAudioUrl);
    }

    setRecordedAudio(null);
    setRecordedAudioUrl(null);
    setAudioDuration(null);
    setIsPlaying(false);
    setPauseicon(false);

    setRestartRecord(true);
    setTimeout(() => setRestartRecord(true), 0);
    setRecordingTime(0);
    localStorage.removeItem("recordedAudio");
    localStorage.removeItem("audioDuration");

  }, [recordedAudioUrl]);
  const [audioFile, setAudioFile] = useState()
  const [voiceUrl, setVoiceUrl] = useState()
  const ffmpeg = new FFmpeg();

  const convertToMp4 = async (audioBlob) => {
    if (!ffmpeg.loaded) await ffmpeg.load();

    const buffer = await audioBlob.arrayBuffer();
    const uint8Array = new Uint8Array(buffer);

    const inputFile = "input.webm"; // or "input.wav" based on your blob
    const outputFile = "output.mp4";

    await ffmpeg.writeFile(inputFile, uint8Array);
    await ffmpeg.exec(["-i", inputFile, outputFile]);

    const outputData = await ffmpeg.readFile(outputFile);

    return new Blob([outputData], { type: "video/mp4" });
  };

  const handleSave = async () => {
    localStorage.setItem("additionalNotes", consulation);
    setInstructionIsLoading(true)
    const additionalNotes = localStorage.getItem("additionalNotes");


    if (!recordedAudio) {
      closeinstructionsModal();
      return;
    }

    try {
      const mp4Blob = await convertToMp4(recordedAudio);

      const formData = new FormData();
      formData.append("file", mp4Blob, "audio.mp4");

      const response = await NodeaxiosInstance.post('product/upload-audio-note',
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status == 200) {
        setVoiceUrl(response.data.file_url);
        localStorage.setItem("recoredURL", response.data.file_url);

        closeinstructionsModal();
      }
    } catch (error) {
      console.error("Upload failed:", error);
    }
  };


  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60).toString().padStart(2, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };



  const getAvailableCourierList = async () => {
    try {
      const response = await NodeaxiosInstance.post('/product/get-courier-services', { cart_id: cartId });


      if (response.status == 200) {
        setAvailableCourierList(response.data.data.available_courier_companies);
        closeDeliveryoptionModal()
        setRecomendedCourier(response.data.data);
        opencourierlistModal()
      }
    } catch (error) {

    }
  }
  const selectCourierDelivery = (courier_company_id) => {

    let data = {
      cart_id: cartId,
      courier_company_id: courier_company_id,
    };
    axiosInstance
      .post("user/products/select_courier_delivery", data)
      .then((res) => {
        if (res.status == 200) {
          getselectProductDetail();
          closecourierlistModal()
        }
      })
      .catch((err) => {



        // setIsLoading(false);
        // setIsPaymentSuccess(true);
        // setShowModal(false);
      });
  };

  const handleReviewAndPay = () => {
    let newErrors = {};

    if (shipingtype == "2") {
      if (!productDetail?.delivery_location_status) {
        newErrors.paybtn = "Please select the delivery address to proceed.";
      } else if ((productDetail?.delivery_slot_status == '0' || timeChangeType == true) && (productDetail.delivery_type != 2)) {
        newErrors.paybtn = "Please select the delivery options to continue.";
      }
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    if (Object.keys(newErrors).length > 0) return;

    if (productDetail?.applied_card_detail?.offer_type == "4") {
      if (
        productDetail?.applied_card_detail?.combo_count !=
        productDetail?.cart_count
      ) {
        return toast(
          `You must select exactly ${productDetail?.applied_card_detail?.combo_count} products to use this offer.`,
          {
            position: "bottom-center",
            autoClose: 2000,
            hideProgressBar: true,
            className: "text-danger toast-style-1",
          }
        );
      }

      return handleConfirmPurchase();
    }

    const totalCount =
      productDetail?.cart_products?.reduce(
        (acc, item) => acc + Number(item.added_count),
        0
      ) || 0;

    if (
      productDetail?.applied_card_detail?.offer_type === "1" &&
      productDetail?.applied_card_detail?.min_quantity > totalCount
    ) {
      return toast(
        `This offer requires a minimum purchase of ${productDetail?.applied_card_detail?.min_quantity} items.`,
        {
          position: "bottom-center",
          autoClose: 2000,
          hideProgressBar: true,
          className: "text-danger toast-style-1",
        }
      );
    }

    if (
      productDetail?.applied_card_detail?.offer_type == "1" &&
      Number(productDetail?.sub_total) <
      Number(productDetail?.applied_card_detail?.min_pur_amount)
    ) {
      return toast(
        `A minimum purchase value of ₹${productDetail?.applied_card_detail?.min_pur_amount} is required to use this offer.`,
        {
          position: "bottom-center",
          autoClose: 2000,
          hideProgressBar: true,
          className: "text-danger toast-style-1",
        }
      );
    }

    return handleConfirmPurchase();
  };


  // const isShippingAllowed =
  //   (shipingtype == "2" && productDetail?.delivery_location_status == true && (productDetail?.delivery_slot_type == "2" || productDetail?.delivery_slot_status != "0"))
  //   ||
  //   shipingtype == "1" ||
  //   shipingtype == "0" ||
  //   flow == "LoyaltyProduct" ||
  //   productDetail?.delivery_type == 2;

  // const getButtonText = () => {
  //   if (!token) return "Login and pay";

  //   if (isLoading) return "loading";

  //   if (flow === "LoyaltyProduct") return "Redeem Now";

  //   if (
  //     selectpaytype == 3 ||
  //     productDetail?.edit_order_datails?.refund_status == 1 ||
  //     (productDetail?.edit_order_datails?.pay_status == 0 &&
  //       productDetail?.edit_order_datails?.refund_status == 0)
  //   ) {
  //     return "Confirm Purchase";
  //   }

  //   const amount =
  //     selectpaytype == 2
  //       ? Number(productDetail?.payment_options?.advance_amount || 0) +
  //       Number(deliverytipamt || 0)
  //       : productDetail?.edit_order_datails?.pay_status == 1
  //         ? productDetail?.edit_order_datails?.balance_amount
  //         : Number(productDetail?.total_amount || 0) + Number(deliverytipamt || 0);

  //   return `Pay ₹${Number(amount).toFixed(2)}`;
  // };


  return (
    <>

      <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white  " >
        <div className="d-flex justify-content-between align-items-center ms-2 me-2">
          <img src={p_nav_previous} width={"24px"} height={"16px"} alt="Previous Button" role="button" onClick={() => {
            if (fromPage == 'addAddress') {
              navigate(-5)
            } else {
              navigate(-1)
            }
          }} />
          <div className="ff-balooPaaji2-bold fs-20 ms-2 ps-1">
            {loyaltyOfferDetails.offer_id ? "Review & Redeem" : " Review & Pay"}
          </div>
        </div>
      </div>

      {
        pageLoaded ?
          <div className={`${!isModalOpen ? "scroller-style-y" : ""}  pisition-relative`}>

            {/* Edit addon model  */}
            <div className="offcanvas addOnModalOffcancas" tabIndex="-1" ref={addonEditeModalRef} >
              <div className=" d-flex justify-content-end mt-1" onClick={() => closeEditAddonModal()}>
                <div className="fs-20 ff-poppins-semiBold me-2 crossContainer" ><CgClose /> </div>
              </div>

              <div className="addOnModel_scroll insideAddon"  >
                <div className="editAddonTitleCont">
                  <div className="editAddonTitle">Your Addons</div>
                  <p className="editaddonBtn" onClick={() => handelEdittoAddonmodel()}>Edit</p>
                </div>
                <div className="addonProductListCont  " style={{ margin: '19px 0px' }}>
                  {productDetail?.cart_products?.length > 0 &&
                    productDetail?.cart_products?.map((item, itemIndex) => {
                      if (productid !== item.product_id) return null;

                      const selectedAddons = item?.addons?.flatMap((addon) => addon?.options?.filter((option) => item?.added_addons?.includes(option?.id)) || []) || [];

                      return (
                        <React.Fragment key={itemIndex}>
                          {selectedAddons.length > 0 ? (
                            selectedAddons.map((option, optionIndex) => (
                              <div
                                className="addonProductCont"
                                key={optionIndex}
                                style={{ margin: "0px 0px" }}
                              >
                                <div className="addonProductLeft">
                                  {(option?.type == "1" || option?.type == "2") && (
                                    <img
                                      src={option?.type == "1" ? vegIcon : nonvegIcon}
                                      height="13px"
                                      width="13px"
                                    />
                                  )}
                                  <div className="addonProductName">{option?.name}</div>
                                </div>
                                <div className="addonProductRight">
                                  <div className="addonPrice" style={{ lineHeight: "16px" }}>
                                    +&nbsp;<span className="rupeeIcon">₹</span>
                                    {option?.price}
                                  </div>
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className="ff-poppins-semiBold w-100 text-center fs-12 mt-1 me-1" key={`no-addon-${itemIndex}`}  >
                              No addons added
                            </div>
                          )}
                        </React.Fragment>
                      );
                    })}
                </div>

                <div className="mt-3" style={{ backgroundColor: '#fff', position: "sticky", bottom: 0, width: '100%' }}>
                  <div className=" ">
                    {productDetail?.cart_products?.length > 0 &&
                      productDetail?.cart_products?.map((item) => (
                        <div className="ff-poppins-regular ">
                          {productid == item.product_id && item.added_count > 0 && (
                            <div>
                              <div className="d-flex justify-content-between">
                                <div className="  d-flex fs-14 col-4  ">
                                  <div className="col-2">
                                    <FiMinusCircle
                                      className="  primary-text fontSizeCountIcon"
                                      onClick={() => {
                                        setProductCount((prevCount) => {
                                          const newCount = Math.max(prevCount - 1, 0);
                                          if (newCount == 0) {
                                            Add_Remove_productcount(item.product_id, "remove");
                                            closeEditAddonModal()
                                          }
                                          return newCount;
                                        });
                                      }} />
                                  </div>
                                  <div className=" col-2 ms-1 d-flex justify-content-center">
                                    {productCount}
                                  </div>
                                  <div className="col-2">
                                    {/* <LiaPlusCircleSolid
                                      className={` primary-text fontSizeCountIcon ${productCount == item.max_allowed_quantity ? "opacity_Cls rounded-circle" : ""}`}
                                      onClick={() => {
                                        if (productCount != item?.max_allowed_quantity) {
                                          setProductCount((prevCount) => prevCount + 1);
                                          setProductid(item.product_id)
                                        } else {
                                          toast("You have reached maximum order product", { position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: "text-danger toast-style-1", });
                                        }
                                      }} /> */}
                                    <LiaPlusCircleSolid
                                      className={`primary-text fontSizeCountIcon ${(item.max_allowed_quantity && productCount >= Number(item.max_allowed_quantity)) ||
                                        (item.stock_status == 1 && productCount >= Number(item.stock_quantity)) ? "opacity_Cls rounded-circle" : ""}`}
                                      onClick={() => {
                                        const maxQty = item.max_allowed_quantity ? Number(item.max_allowed_quantity) : Infinity;
                                        const stockQty = Number(item.stock_quantity);

                                        if (productCount < stockQty && productCount < maxQty) {
                                          setProductCount((prevCount) => prevCount + 1);
                                          setProductid(item.product_id);
                                        } else if (item.stock_status == 1 && productCount >= stockQty) {
                                          toast("No more stock left for this product", {
                                            position: "bottom-center",
                                            autoClose: 2000,
                                            hideProgressBar: true,
                                            className: "text-danger toast-style-1",
                                          });
                                        } else if (productCount >= maxQty) {
                                          showToast("You have reached maximum order product");
                                        }
                                      }}
                                    />

                                  </div>
                                </div>
                                <div className="ff-poppins-semiBold fs-14 primary-text">
                                  Cost : <span className="rupeeIcon ">&nbsp;₹</span>{(productCount) * (Number(item.price) + Number(item.addons_cost))}
                                </div>
                              </div>
                              <div className="col-12">
                                <button type="button" className="btn-type-1 ff-poppins-semiBold mt-2 fs-14 w-100 primary-bg border-0 text-white justify-content-center d-flex align-items-center"
                                  onClick={() => confirmUpdate()} >
                                  Confirm
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      )
                      )}
                  </div>
                </div>
              </div>
            </div>

            {/* Add addon model  */}
            <div className="offcanvas addOnModalOffcancas" tabIndex="-1"
              style={{ borderTopLeftRadius: 15, borderTopRightRadius: 15, width: 390, zIndex: 7777, height: 'max-content' }} ref={addonModalRef}  >
              <div className=" d-flex justify-content-end mt-1" onClick={() => { closeAddonModal(); setSelectedAddons([]) }}>
                <div className="fs-20 ff-poppins-semiBold me-2 crossContainer" ><CgClose /> </div>
              </div>
              <div className="insideAddon  " >
                <div className="addonContainer addOnModel_scroll">
                  {productDetail?.cart_products?.length > 0 &&
                    productDetail?.cart_products?.map((item, productItemIndex) => {
                      return productid == item?.product_id ?
                        item?.addons?.map((addon, addonIndex) => (
                          <div className="AddonCategoryCont" key={addonIndex} >
                            <div className="addonCatgoryContTop">
                              <h6 className="addonCategoryTitle">Choose {addon?.addon_name}</h6>
                              <div className="addonCategorySubtitle">select any (optional)</div>
                            </div>
                            <div className="addonProductListCont">
                              {addon?.options?.map((option, optionIndex) => (
                                <div className="addonProductCont" key={`${optionIndex}-${optionIndex}`}>
                                  <div className="addonProductLeft">
                                    {(option?.type == "1" || option?.type == "2") && (
                                      <img src={option?.type == "1" ? vegIcon : nonvegIcon} height="13px" width="13px" />
                                    )}
                                    <div className="addonProductName">
                                      {option?.name}
                                    </div>
                                  </div>
                                  <div className="addonProductRight">
                                    <div className="addonPrice">+&nbsp;<span className="rupeeIcon">₹</span>{option?.price}</div>
                                    {
                                      checkIsSelectedAddon(addon.id, option.id) ?
                                        <div onClick={() => { selectAddon(addon, option.id, option?.price, option); setProductid(addon?.product_id) }} className="checkBoxContainer"> <FaSquareCheck size={18} /> </div>
                                        :
                                        <div onClick={() => { selectAddon(addon, option.id, option?.price, option); setProductid(addon?.product_id) }} className="checkBoxContainer" > <FaRegSquare size={18} /></div>
                                    }
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )) : ""
                    })
                  }
                </div>

                <div style={{ backgroundColor: '#fff', position: "sticky", bottom: 0, width: '100%' }}>
                  <div className=" p-1  ">
                    <p className="m-0 d-flex justify-content-end primary-text ff-poppins-semiBold fs-14 mb-1">
                      Cost : <span className="rupeeIcon ">₹</span>{(Number(productCost)) + ((productCount) * (Number(selectItem.price) + Number(selectItem.addons_cost)))}
                    </p>
                    <button type="button" className="btn-type-1 ff-poppins-semiBold fs-14 w-100 primary-bg border-0 text-white justify-content-center d-flex align-items-center"
                      onClick={() => checkButtonStatus()}  >
                      Confirm
                    </button>
                  </div>
                </div>

              </div>
            </div>

            <div>
              <div className="p-2 secondary-bg-1">
                <div className="p-3 bg-white rounded-4">
                  {shipingtype == '2' ? (
                    <div className="mb-4 mt-4">
                      <div className="ff-balooPaaji2-bold mb-2">
                        Delivery Address
                      </div>
                      {!deliverylocation?.address ? (
                        <button disabled={userData?.user_type == "User" ? false : true} className={"border border-black border-opacity-10 w-100 ff-balooPaaji2-semiBold rounded p-2 bg-white "}
                          onClick={() => { getuserLocationList(); setLocationBtnloder(false); setIsModalOpen(true); setErrors({}) }}  >
                          {locationBtnloder ? "Add Address"
                            : <div className="d-flex justify-content-center">
                              <ReactLoading type={"spinningBubbles"} color={"#4E26A3"} style={{ height: 24, width: 24 }} />
                            </div>} </button>
                      ) : (
                        <div onClick={() => flowtype !== "EDIT_ORDER" && (getuserLocationList())}>
                          <div className={`border rounded d-flex p-2 ${flowtype == "EDIT_ORDER" ? "opacity_Cls" : ""} `}>
                            <div className="col-2 ">
                              <div className="border w-100 border-black border-opacity-10 rounded d-flex justify-content-center mt-2 fs-24 primary-text py-2">
                                {deliverylocation?.location_type_id == 1 ? (
                                  <IoMdHome className="primary-text" />
                                ) : deliverylocation?.location_type_id == 2 ? (
                                  <MdWork className="primary-text" />
                                ) : (
                                  <IoLocationSharp />
                                )}
                              </div>
                            </div>
                            <div className="col-9">
                              <p className="m-0 ps-3 ff-poppins-bold">
                                {deliverylocation?.location_type}{" "}
                              </p>
                              <p className="m-0 ps-3 ff-poppins-regular singleline-text fs-12">
                                {deliverylocation?.address}
                              </p>
                              <p className="m-0 ps-3 ff-poppins-regular fs-12">
                                {deliverylocation?.distance?.text} - {deliverylocation?.duration?.text}
                              </p>
                            </div>
                            <div className="col-1 ms-2 mt-3">
                              <IoIosArrowForward />
                            </div>
                          </div>
                        </div>
                      )}

                    </div>
                  ) :
                    <></>
                  }
                  {
                    userData?.user_type == "User" ?
                      shipingtype == '2' ?
                        <div className="secondary-box rounded-3">
                          <div className="p-2">
                            <div className="secondary-bg-4 rounded-4" style={{ padding: '6px 8px', display: "flex", justifyContent: "center" }}>
                              <div className="Tab-container">
                                <div
                                  className="highlight"
                                  style={{
                                    transform: `translateX(${(delivery_option - 1) * 100}%)`
                                  }}
                                ></div>

                                <div
                                  className={`Tab-design fs-10 ff-poppins-semiBold ${delivery_option === 1 ? "text-white" : ""}`}
                                  onClick={() => setDelivery_option(1)}
                                >
                                  Delivery Type
                                </div>
                                <div
                                  className={`Tab-design fs-10 ff-poppins-semiBold ${delivery_option === 2 ? "text-white" : ""}`}
                                  onClick={() => setDelivery_option(2)}
                                >
                                  Tip
                                </div>
                                <div
                                  className={`Tab-design fs-10 ff-poppins-semiBold ${delivery_option === 3 ? "text-white" : ""}`}
                                  onClick={() => setDelivery_option(3)}
                                >
                                  Instructions
                                </div>
                              </div>
                            </div>


                            {

                              delivery_option == 1 ?
                                <div className="mt-3">
                                  {
                                    productDetail.pre_order_status != 1 ?

                                      productDetail?.delivery_slot_status == '0' ?
                                        <p className="text-center fs-12 p-0 m-0  ff-poppins-regular secondary-text-1 ">Choose a delivery type for a smooth drop-off!</p> :
                                        <p className="text-start fs-12 p-0 m-0  ff-poppins-medium secondary-text-1 ">To change delivery type {" "}
                                          <span onClick={() => { ChangeSlotType(); setDeliverytype("instore"); setOtherdeliveryoption(true); }} className="primary-text ">click here!</span></p>

                                      : ""
                                  }
                                  {shipingtype == '2' ?
                                    (productDetail?.delivery_slot_status == '0' || timeChangeType == true) && (productDetail.delivery_type != 2) ?

                                      <div className="" onClick={() => productDetail.delivery_location_status == true ? openDeliveryoptionModal() :
                                        toast("Please add a delivery address to continue", {
                                          position: "bottom-center", autoClose: 2000, hideProgressBar: true,
                                          closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: 'text-danger toast-style-1'
                                        })}>
                                        <div className="border border-black border-opacity-10 p-2 rounded-2 mt-2">
                                          <div className="d-flex align-items-center w-100">
                                            <div
                                              className="border border-black border-opacity-10 rounded  d-flex justify-content-center align-items-center  primary-text"
                                              style={{ width: "40px", height: "40px" }}
                                            >
                                              <RiEBikeFill size={20} />
                                            </div>

                                            <h6 className="fs-12 ff-poppins-semiBold primary-text ms-3 mb-0">
                                              Choose delivery option
                                            </h6>
                                          </div>
                                        </div>
                                      </div>
                                      :
                                      <div className="d-flex justify-content-between align-items-center secondary-box mt-2 mb-1 rounded-3 p-2">

                                        <div>
                                          {
                                            productDetail.delivery_type == 2 ?
                                              <div>
                                                <h6 className="p-0 m-0 fs-12 ff-poppins-semiBold">{productDetail.shipping_details.courier_name} </h6>
                                                <p className="p-0 m-0 fs-10 ff-poppins-regular">Courier delivery, at your door on time </p>
                                              </div>
                                              :
                                              productDetail.pre_order_status == 1 ?

                                                <>
                                                  <h6 className="p-0 m-0 fs-12 ff-poppins-semiBold">Pre-order Delivery</h6>
                                                  <p className="p-0 m-0 fs-10 ff-poppins-regular">Slot delivery,at your door on time </p>

                                                  {/* <span className="primary-text">{productDetail.pre_order_date} </span> */}

                                                  <p className="p-0 m-0 fs-10 ff-poppins-medium primary-text">
                                                    {productDetail.pre_order_status != 1
                                                      ? `${new Date(productDetail.pre_order_date).toLocaleTimeString('en-US', {
                                                        hour: 'numeric',
                                                        minute: '2-digit',
                                                        hour12: true
                                                      }).toLowerCase()}
                                                      ${new Date(productDetail.pre_order_date).toLocaleDateString('en-US', {
                                                        month: 'long',
                                                        day: 'numeric',
                                                        year: 'numeric'
                                                      })}`
                                                      : `${new Date(productDetail.pre_order_date).toLocaleDateString('en-US', {
                                                        month: 'long',
                                                        day: 'numeric',
                                                        year: 'numeric'
                                                      })}`}
                                                  </p>

                                                </>
                                                :
                                                productDetail?.delivery_slot_type == '2' ?
                                                  <>
                                                    <h6 className="p-0 m-0 fs-12 ff-poppins-semiBold">Any Time</h6>
                                                    <p className="p-0 m-0 fs-10 ff-poppins-regular">This product will be delivered within 3 days.</p>
                                                  </>
                                                  : productDetail?.delivery_slot_type == '1' ?
                                                    <>
                                                      <h6 className="p-0 m-0 fs-12  ff-poppins-semiBold">Slot Delivery</h6>
                                                      <p className="p-0 m-0 fs-10  ff-poppins-regular">Slot delivery, at your door on time!</p>
                                                      <p className="p-0 m-0 fs-10  ff-poppins-medium primary-text">
                                                        {productDetail?.order_delivery_date_time?.delivery_time}

                                                        {" "} {new Date(productDetail?.order_delivery_date_time?.delivery_date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
                                                      </p>
                                                    </> : productDetail?.delivery_slot_type == '3' ?
                                                      <>
                                                        <h6 className="p-0 m-0 fs-12 ff-poppins-semiBold">Instant Delivery</h6>
                                                        <p className="p-0 m-0 fs-10 ff-poppins-regular">At your door in <span className="primary-text">30 minutes!</span></p>
                                                      </> : ""
                                          }
                                        </div>
                                        {/* {
                                          productDetail.pre_order_status != 1 || flow != "LoyaltyProduct" &&
                                          <div>
                                            <p className="m-0 d-flex justify-content-end primary-text ff-poppins-semiBold fs-14" onClick={() => { ChangeSlotType(); setDeliverytype("doorstep") }}>Change</p>
                                          </div>
                                        } */}
                                      </div> : ""
                                  }
                                </div>
                                :
                                delivery_option == 2 ?
                                  <div className="mt-3 ">
                                    <div>
                                      <p className="text-center fs-11 p-0 m-0  ff-poppins-regular  secondary-text-1 ">Rain or shine,delivery partner bring your favorite meals.<br /> show them same love with tip!</p>

                                      <div className={`d-flex justify-content-between mt-3 ${tipOption == 4 ? "" : "mb-3"}`} >
                                        <div
                                          className={`${tipOption === 1 ? "select-tip-box" : "tip-box"} d-flex align-items-center justify-content-center`}
                                          onClick={() => handleTipSelection(1, 20)}   >
                                          <span className="d-flex align-items-center">
                                            <FaIndianRupeeSign size={10} />
                                            <span>20</span>
                                          </span>
                                          {tipOption === 1 && <IoMdClose className="ms-2" />}
                                        </div>
                                        <div
                                          className={`${tipOption == 2 ? "select-tip-box" : "tip-box"} d-flex align-items-center justify-content-center`}
                                          onClick={() => handleTipSelection(2, 30)}      >
                                          <span className="d-flex align-items-center">
                                            <FaIndianRupeeSign size={10} />
                                            <span>30</span>
                                          </span>
                                          {tipOption == 2 && <IoMdClose className="ms-2" />}
                                        </div>
                                        <div
                                          className={`${tipOption == 3 ? "select-tip-box" : "tip-box"} d-flex align-items-center justify-content-center`}
                                          onClick={() => handleTipSelection(3, 50)} >
                                          <span className="d-flex align-items-center">
                                            <FaIndianRupeeSign size={10} />
                                            <span>50</span>
                                          </span>
                                          {tipOption == 3 && <IoMdClose className="ms-2" />}
                                        </div>
                                        <div
                                          className={`${tipOption == 4 ? "select-tip-box" : "tip-box"}  d-flex align-items-center justify-content-center gap-1`}
                                          onClick={() => handleTipSelection(4,)} >
                                          <span>{tipOption == 4} Other</span>
                                          {tipOption == 4 && <IoMdClose className="" size={16} />}
                                        </div>
                                      </div>

                                      {
                                        tipOption == 4 &&
                                        <div className="mt-2 w-100 text-center d-flex justify-content-center mb-3">
                                          <span style={{ fontSize: '14px', fontWeight: '500' }}>₹</span>
                                          <input
                                            type="text"
                                            placeholder="Enter tip amount"
                                            maxLength={3}
                                            value={deliverytipamt}
                                            onChange={(e) => {
                                              const numericValue = e.target.value.replace(/\D/g, "");
                                              setDeliveryTipamt(numericValue);
                                            }}
                                            onKeyDown={(e) => {
                                              if (e.key === "Enter") {
                                                e.target.blur(); // ✅ closes mobile keyboard
                                              }
                                            }}
                                            className="tip-amount-input text-left ff-poppins-semiBold fs-13"
                                            style={{ padding: '2px 0px 2px 2px', width: '40%' }}
                                          />
                                        </div>
                                      }

                                    </div>
                                  </div> :
                                  delivery_option == 3 ?
                                    <div className="mt-3 cursorDefault">
                                      <div>
                                        <p className="text-center fs-11 p-0 m-0  ff-poppins-regular  secondary-text-1 ">Add delivery instructions for a smooth drop-off!</p>
                                        <div className=" d-flex  scroller-style-x ">

                                          <div className="d-flex mt-3 overflow-auto scroller-style-x">
                                            {[
                                              { id: 1, icon: bell_icon, label: "Don't ring the bell" },
                                              { id: 2, icon: door_icon, label: "Leave at the door" },
                                              { id: 3, icon: Avoid_call, label: "Avoid Calling" },
                                              { id: 4, icon: gurard_icon, label: "Leave with guard" },
                                              { id: 5, icon: pet_foot, label: "Pet at home" }
                                            ].map((option) => (
                                              <div
                                                key={option.id}
                                                className={`${instructionsOption.includes(option.label) ? "select-primary-box" : ""} Instructions-box mx-1`}
                                                onClick={() => handleOptionToggle(option.label)}
                                              >
                                                <img src={option.icon} alt={option.label} className="instrctionIcons" />
                                                <p className="fs-10 ff-poppins-semiBold p-0">{option.label}</p>
                                              </div>
                                            ))}
                                          </div>
                                        </div>
                                        {recordedAudio || consulation ?
                                          <div className="addedInstructionContainer d-flex justify-content-between align-items-center w-100 p-2 mt-1" onClick={() => toggleshowInstruction()} >
                                            <div className="addedInstrcRight d-flex align-items-center gap-1">
                                              <FaCircleCheck size={14} className="flex-shrink-0" />
                                              <span>Instruction added</span>
                                            </div>
                                            <div className="addedInstrcRight">
                                              Edit
                                            </div>
                                          </div>
                                          :
                                          <div>
                                            <p className="p-0 m-0 fs-12 ms-2 ff-poppins-semiBold mt-2   primary-text" onClick={() => toggleshowInstruction()}>+  Add an instructions note</p>
                                          </div>
                                        }
                                      </div>
                                    </div>
                                    : ""
                            }
                          </div>
                        </div>
                        : shipingtype == '0' ?
                          <div>
                            <h6 className="fs-14 ff-poppins-bold">Delivery Option</h6>
                            <div className="d-flex justify-content-between align-items-center secondary-box mt-2 rounded-3 p-2">
                              <div>
                                <h6 className="p-0 m-0 fs-12 ff-poppins-semiBold"> Dine-in</h6>
                                <p className="p-0 m-0 fs-10 ff-poppins-regular">Convenient dine-in service</p>
                              </div>

                              {
                                flow == "LoyaltyProduct" ?
                                  "" :
                                  productDetail.pre_order_status != 1 && shipingtype == 2 &&
                                  <div>
                                    <p className="m-0 d-flex justify-content-end primary-text ff-poppins-semiBold fs-14" onClick={() => { ChangeSlotType(); setDeliverytype("instore"); setOtherdeliveryoption(true); }}>Change</p>
                                  </div>}
                            </div>
                          </div>
                          :
                          <div>
                            <h6 className="fs-14 ff-poppins-bold">Delivery Option</h6>
                            <div className="d-flex justify-content-between align-items-center secondary-box mt-2 rounded-3 p-2">
                              <div>
                                <h6 className="p-0 m-0 fs-12 ff-poppins-semiBold">Instore pickup </h6>
                                <p className="p-0 m-0 fs-10 ff-poppins-regular">Hassle-free in-store pickup </p>
                              </div>

                              {
                                flow == "LoyaltyProduct" ?
                                  "" :
                                  productDetail.pre_order_status != 1 && shipingtype != 1 &&
                                  <div>
                                    <p className="m-0 d-flex justify-content-end primary-text ff-poppins-semiBold fs-14" onClick={() => { ChangeSlotType(); setDeliverytype("instore"); setOtherdeliveryoption(true); }}>Change</p>
                                  </div>}
                            </div>
                          </div>

                      : ""
                  }

                  {productDetail &&
                    productDetail?.card_applied_status == 1 &&
                    productDetail?.applied_card_detail?.card_type == "offer" &&
                    productDetail?.applied_card_detail?.offer_type == 3 ? (
                    <div className="offcanvas-parentType3 position-relative">
                      <h6 className="ff-poppins-bold fs-16">Buy products</h6>

                      {productDetail && productDetail?.offer_detail?.buy_products &&
                        productDetail?.offer_detail?.buy_products?.length > 0 ? (
                        productDetail?.offer_detail?.buy_products.map((item, index) => {
                          return (

                            <div className="productDiv">
                              <div className="col-3 ">
                                <div className="imgBox position-relative productImageDiv ">
                                  <img src={item.cover_image.image == "" ? defaultproductimg : item.cover_image.image_url} className="rounded-3 productImage" height="90px" width="90px" />
                                </div>
                              </div>
                              <div className="col-9">
                                <div className=" ms-1">
                                  <div className="d-flex align-items-center">
                                    {vendorType == "9" &&
                                      <img src={item.food_type == "1" ? vegIcon : item.food_type == "2" ? nonvegIcon : item.food_type == "3" ? eggIcon : ""} height="13px" width="13px" className="me-1" />
                                    }
                                    <span className="ff-poppins-semiBold fs-12">{
                                      item.product_name?.length > 40
                                        ? item.product_name.slice(0, 36) + "..."
                                        : item.product_name
                                    } </span>
                                  </div>

                                  <div className="ff-poppins-semiBold  fs-12 me-1 m-0">
                                    <span className="rupeeIcon ">₹</span>{item.price}{" "}
                                    {productDetail?.applied_card_detail?.offer_type == 1 || productDetail?.applied_card_detail?.card_type == "membership" ?
                                      <span className="primary-text fs-11 ff-poppins-regular"> {item.benefit ? ('(' + item.benefit_lable + ')') : ''} </span>
                                      : ""
                                    }
                                  </div>
                                  <p className="ff-poppins-semiBold primary-text fs-9 m-0">
                                    {item.unit_quantity} {item.unit_type_name}
                                  </p>

                                  <div className="moreDetailsDiv primary-text">
                                    <p className="moreInfobtn ff-poppins-semiBold fs-10 px-0 m-0"
                                      onClick={() => navigate(`/product/${vendorId}/${item.product_id}`, { state: { productId: item.product_id, vendorId, flow: 'offerBooking', orderType: 'userbooking' } })}  >
                                      More details
                                    </p>
                                    <IoIosArrowDown className="fw-bold productWeightBasket " />
                                  </div>

                                  {item.stock_status == "1" ? (

                                    item.stock_quantity == 0 ?
                                      <span className="text-danger fs-10 p-0 m-0 ff-poppins-semiBold"> Out of stock</span> :
                                      productDetail?.cart_products?.filter((product) => product.product_id == item.product_id).length > 0 ? (
                                        productDetail?.cart_products?.filter((product) => product.product_id == item.product_id)
                                          .map((product) => (
                                            <div key={product.product_id}>
                                              <p className="ff-poppins-semiBold primary-text fs-9 m-0">
                                                {item.stock_quantity - (product?.added_count)} left
                                              </p>
                                            </div>
                                          ))
                                      ) : (
                                        <div key={item.product_id}>
                                          <p className="ff-poppins-semiBold primary-text fs-9 m-0">
                                            {item.stock_quantity} left
                                          </p>
                                        </div>
                                      )
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            </div>


                          );
                        }
                        )
                      ) : (
                        <></>
                      )}
                      <h6 className="ff-poppins-bold fs-16 mt-4">
                        Get products<span className="primary-text"> (Free)</span>{" "}
                      </h6>
                      {productDetail && productDetail?.offer_detail?.get_products && productDetail?.offer_detail?.get_products?.length > 0 ? (
                        productDetail?.offer_detail?.get_products.map((item, index) => {
                          return (

                            <div className="productDiv">
                              <div className="col-3 ">
                                <div className="imgBox position-relative productImageDiv ">
                                  <img src={item.cover_image.image == "" ? defaultproductimg : item.cover_image.image_url} className="rounded-3 productImage" height="90px" width="90px" />
                                </div>
                              </div>
                              <div className="col-9">
                                <div className=" ms-1">
                                  <div className="d-flex align-items-center">
                                    {vendorType == "9" &&
                                      <img src={item.food_type == "1" ? vegIcon : item.food_type == "2" ? nonvegIcon : item.food_type == "3" ? eggIcon : ""} height="13px" width="13px" className="me-1" />
                                    }
                                    <span className="ff-poppins-semiBold fs-12"> {
                                      item.product_name?.length > 40
                                        ? item.product_name.slice(0, 36) + "..."
                                        : item.product_name
                                    } </span>
                                  </div>

                                  <div className="ff-poppins-semiBold  fs-12 me-1 m-0">
                                    <span className="rupeeIcon ">₹</span>{item.price}{" "}
                                    {productDetail?.applied_card_detail?.offer_type == 1 || productDetail?.applied_card_detail?.card_type == "membership" ?
                                      <span className="primary-text fs-11 ff-poppins-regular"> {item.benefit ? ('(' + item.benefit_lable + ')') : ''} </span>
                                      : ""
                                    }
                                  </div>
                                  <p className="ff-poppins-semiBold primary-text fs-9 m-0">
                                    {item.unit_quantity} {item.unit_type_name}
                                  </p>

                                  <div className="moreDetailsDiv primary-text">
                                    <p className="moreInfobtn ff-poppins-semiBold fs-10 px-0 m-0"
                                      onClick={() => navigate(`/product/${vendorId}/${item.product_id}`, { state: { productId: item.product_id, vendorId, flow: 'offerBooking', orderType: 'userbooking' } })}  >
                                      More details
                                    </p>
                                    <IoIosArrowDown className="fw-bold productWeightBasket " />
                                  </div>

                                  {item.stock_status == "1" ? (
                                    item.stock_quantity == 0 ?
                                      <span className="text-danger fs-10 p-0 m-0 ff-poppins-semiBold"> Out of stock</span> :
                                      productDetail?.cart_products?.filter((product) => product.product_id == item.product_id).length > 0 ? (
                                        productDetail?.cart_products?.filter((product) => product.product_id == item.product_id)
                                          .map((product) => (
                                            <div key={product.product_id}>
                                              <p className="ff-poppins-semiBold primary-text fs-9 m-0">
                                                {item.stock_quantity - (product?.added_count)} left
                                              </p>
                                            </div>
                                          ))
                                      ) : (
                                        <div key={item.product_id}>
                                          <p className="ff-poppins-semiBold primary-text fs-9 m-0">
                                            {item.stock_quantity} left
                                          </p>
                                        </div>
                                      )
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            </div>

                          );
                        }
                        )
                      ) : (
                        <></>
                      )}
                    </div>
                  ) : (
                    <div>
                      {
                        productDetail.pre_order_status == 1 ?
                          <h6 className="ff-poppins-bold m-0 py-2">Pre-Order Ticket</h6> :
                          <h6 className="ff-poppins-bold m-0 py-2">Products</h6>
                      }
                      {productlist.map((item, index) => {
                        return (
                          <div className="productDiv">
                            <div className="col-3 ">
                              <div className="imgBox position-relative productImageDiv ">
                                <img src={item.cover_image.image == "" ? defaultproductimg : item.cover_image.image_url} className="rounded-3 productImage" height="90px" width="90px" />
                              </div>
                            </div>
                            <div className="col-9">
                              <div className=" ms-1">
                                <div className="d-flex align-items-center">
                                  {vendorType == "9" &&
                                    <img src={item.food_type == "1" ? vegIcon : item.food_type == "2" ? nonvegIcon : item.food_type == "3" ? eggIcon : ""} height="13px" width="13px" className="me-1" />
                                  }
                                  <span className="ff-poppins-semiBold fs-12"> {
                                    item.product_name?.length > 40
                                      ? item.product_name.slice(0, 36) + "..."
                                      : item.product_name
                                  } </span>
                                </div>

                                <div className="ff-poppins-semiBold  fs-12 me-1 m-0">
                                  <span className="rupeeIcon ">₹</span>{item.price}{" "}
                                  {productDetail?.applied_card_detail?.offer_type == 1 || productDetail?.applied_card_detail?.card_type == "membership" ?
                                    <span className="primary-text fs-11 ff-poppins-regular"> {item.benefit ? ('(' + item.benefit_lable + ')') : ''} </span>
                                    : ""
                                  }
                                </div>
                                <p className="ff-poppins-semiBold primary-text fs-9 m-0">
                                  {item.unit_quantity} {item.unit_type_name}
                                </p>

                                <div className="moreDetailsDiv primary-text">
                                  <p className="moreInfobtn ff-poppins-semiBold fs-10 px-0 m-0"
                                    onClick={() => navigate(`/product/${vendorId}/${item.product_id}`, { state: { productId: item.product_id, vendorId, flow: flow, orderType: orderType } })}  >
                                    More details
                                  </p>
                                  <IoIosArrowDown className="fw-bold productWeightBasket " />
                                </div>

                                {item.stock_status == "1" ? (

                                  item.stock_quantity == 0 ?
                                    <span className="text-danger fs-10 p-0 m-0 ff-poppins-semiBold"> Out of stock</span> :
                                    productDetail?.cart_products?.filter((product) => product.product_id == item.product_id).length > 0 ? (
                                      productDetail?.cart_products?.filter((product) => product.product_id == item.product_id)
                                        .map((product) => (
                                          <div key={product.product_id}>
                                            <p className="ff-poppins-semiBold primary-text fs-9 m-0">
                                              {item.stock_quantity - (product?.added_count)} left
                                            </p>
                                          </div>
                                        ))
                                    ) : (
                                      <div key={item.product_id}>
                                        <p className="ff-poppins-semiBold primary-text fs-9 m-0">
                                          {item.stock_quantity} left
                                        </p>
                                      </div>
                                    )
                                ) : (
                                  ""
                                )}
                                <div className={`d-flex justify-content-between`}>
                                  {productDetail?.applied_card_detail?.offer_type == 2 || productDetail?.applied_card_detail?.offer_type == 3 ||
                                    productDetail?.applied_card_detail?.offer_type == 4 || flow == 'LoyaltyProduct' || orderType == "booknow" ? (
                                    <></>
                                  ) : (

                                    <div className="row align-items-center  col-4 gx-0">
                                      <div className="row d-flex justify-content-between w-100 gx-0">
                                        <div className="col-3">
                                          <FiMinusCircle className="w-100 fs-18 primary-text"
                                            onClick={() => Add_Remove_productcount(item?.product_id, "remove")} />
                                        </div>
                                        <div className="col-4 d-flex justify-content-center  primary-text">
                                          {item?.added_count}
                                        </div>
                                        {/* <div className="col-3">
                                            <LiaPlusCircleSolid className={`w-100 primary-text fs-18 ${item.added_count == item.max_allowed_quantity ||
                                              (item.stock_status == 1 && item.added_count >= item.stock_quantity) ? "opacity_Cls rounded-circle" : ""}`}
                                              onClick={() =>
                                                item?.addons == "" ? item?.added_count == item?.max_allowed_quantity ? "" :
                                                  item.stock_status == 1 && item.added_count >= item.stock_quantity ? "" :
                                                    Add_Remove_productcount(item?.product_id, "add") :
                                                  openEditAddonModal(item?.addons, item?.added_addons, item?.product_id, item?.added_count, item)} />
                                          </div> */}


                                        <div className="col-3">
                                          <LiaPlusCircleSolid
                                            className={`w-100 primary-text fs-18 ${item.added_count == item.max_allowed_quantity ||
                                              (item.stock_status == 1 && item.added_count >= item.stock_quantity)
                                              ? "opacity_Cls rounded-circle"
                                              : ""
                                              }`}
                                            onClick={() => {
                                              if (item?.addons == "") {
                                                if (item?.added_count == item?.max_allowed_quantity) {
                                                  showToast("You’ve reached the maximum allowed quantity.",);
                                                  return;
                                                }

                                                if (item.stock_status == 1 && item.added_count >= item.stock_quantity) {
                                                  toast("No more stock left for this product", { position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: false, theme: "light", className: "text-danger toast-custom-style toast-style-1", });
                                                  return;
                                                }
                                                Add_Remove_productcount(item?.product_id, "add");
                                              } else {
                                                openEditAddonModal(
                                                  item?.addons,
                                                  item?.added_addons,
                                                  item?.product_id,
                                                  item?.added_count,
                                                  item
                                                );
                                              }
                                            }}
                                          />
                                        </div>

                                      </div>
                                    </div>

                                  )}


                                  {
                                    productDetail?.applied_card_detail?.offer_type == 2 || orderType == "booknow" ? "" :

                                      flow != 'LoyaltyProduct' && productDetail?.applied_card_detail?.offer_type != 4 ?
                                        <div className="col-2 deleteIconProductBasket me-3">
                                          <MdOutlineDeleteOutline
                                            onClick={() => (opendelectorderModal(), setDeleteitem(item))} />
                                        </div>
                                        : <></>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                          // <div className=" d-flex justify-content-between">
                          //   <div className="d-flex align-items-center mt-2">
                          //     {vendorType == "9" &&
                          //       <img src={item.food_type == "1" ? vegIcon : item.food_type == "2" ? nonvegIcon : item.food_type == "3" ? eggIcon : ""} className="food-type-icon" />
                          //     }
                          //     <span className="ff-poppins-semiBold fs-12"> {
                          //       item.product_name?.length > 40
                          //         ? item.product_name.slice(0, 36) + "..."
                          //         : item.product_name
                          //     } </span>
                          //   </div>
                          //   <div className="productAddRemoveBtn">
                          //     <FaPlus className="productAddRemoveBtnIcon"/>
                          //     <div className=" text-center fs-12 primary-text">
                          //       {item?.added_count}
                          //     </div>
                          //     <FaMinus  className="productAddRemoveBtnIcon"/>

                          //   </div>
                          // </div>
                        );
                      })}

                      {
                        productDetail.pre_order_status == 1 ?
                          <div className="mb-2">
                            <div className={`preorder-card-main-box  ${productDetail?.preorder_ticket?.card_colour && productDetail?.preorder_ticket?.card_colour !== "transparent" && "ImageDesign"}`}
                              style={{
                                background: productDetail?.preorder_ticket?.card_colour && productDetail?.preorder_ticket?.card_colour !== "transparent" ? productDetail?.preorder_ticket?.card_colour : productDetail?.preorder_ticket?.card_pattern ? `url(${productDetail?.preorder_ticket?.card_pattern})` : 'rgb(231, 52, 96)', backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat", width: "345px"
                              }}    >

                              <div className="conatiner-left">

                                <img src={`${productDetail?.preorder_ticket?.images || DEFAULT_Ticket_IMAGE_URL}`}
                                  alt="Preview"
                                  className="image" width={"100px"} height={"165px"}
                                  onError={(e) => e.target.src = DEFAULT_Ticket_IMAGE_URL}
                                />
                              </div>

                              <div className="conatiner-right-Card">

                                <div className="content-top p-0 d-flex justify-content-between align-items-center">
                                  <span className="store-name p-0 fs-14 ff-poppins-semiBold text-white">
                                    {productDetail?.preorder_ticket?.vendor_company_name}
                                  </span>
                                  <span></span>
                                </div>
                                <div className="content-bottom">
                                  <span className=" fs-14 ff-poppins-semiBold text-uppercase text-white ">
                                    {productDetail?.preorder_ticket?.ticket_name || "TICKET NAME"}
                                  </span>
                                  <div className="gradient-line"
                                    style={{
                                      width: `${Math.min(productDetail?.preorder_ticket?.ticket_name?.length * 20, 200) || 200
                                        }px`,
                                      marginTop: 0,
                                      marginBottom: "10px",
                                    }}
                                  ></div>
                                  <p className="content ff-poppins-regular fs-10 text-white">
                                    {(
                                      productDetail?.preorder_ticket?.about ||
                                      "This ticket is for food, making preordering easy, convenient, budget..."
                                    ).slice(0, 70) + (productDetail?.preorder_ticket?.about?.length > 70 ? "..." : "")}
                                  </p>
                                  <span className="price fs-14 ff-poppins-semiBold text-white">
                                    <span className="rupeeIcon">₹</span>{productDetail?.preorder_ticket?.ticket_price || "00.0"}
                                  </span>
                                </div>
                                {/* <div className="footer py-2">
                                   <span className="bottom-left fs-12 ff-poppins-regular text-white"></span>
                                   <button className="buyNow fs-12 ff-poppins-regular">
                                       Buy Now <FiArrowRight className="ms-1" />
                                   </button>
                               </div> */}
                              </div>

                            </div>
                          </div> : ""
                      }
                    </div>
                  )}

                  <div className="d-flex mt-2">
                    <div className="addItembtn" onClick={() => navigate(`/products/${vendorId}`, { state: { flowtype: 'addItems' } })}>
                      <span>
                        <FaPlus />
                      </span>
                      <span className="ms-1">
                        Add Items
                      </span>
                    </div>

                    <div className={`addItembtn ms-2 ${confirmAdditionalCookingNotes ? 'secondary-bg-4 text-dark' : ''}`}
                      onClick={() => {
                        if (confirmAdditionalCookingNotes) {
                          setAdditionalCookingNotes('');
                          setConfirmAdditionalCookingNotes('');
                          setShowAdditionalCookingNotes(false);

                        } else {
                          setShowAdditionalCookingNotes(true);
                        }
                      }}
                    >
                      {!confirmAdditionalCookingNotes &&
                        <span>
                          <TfiPencil />
                        </span>}
                      <span className="ms-1">
                        Add notes
                      </span>
                      {
                        confirmAdditionalCookingNotes &&

                        <span className="ms-2">
                          <CgCloseO />
                        </span>
                      }

                    </div>
                  </div>
                  {(showAdditionalCookingNotes == true || confirmAdditionalCookingNotes) &&
                    <div className=" ">
                      <div className="mt-2 w-100 d-flex align-items-center mb-3">

                        {confirmAdditionalCookingNotes ? (
                          <div className="fs-12 ff-poppins-medium secondary-text-1 text-break" onClick={() => {
                            setAdditionalCookingNotes(confirmAdditionalCookingNotes);
                            setShowAdditionalCookingNotes(true)
                            setTimeout(() => {
                              setConfirmAdditionalCookingNotes('')
                            }, 200);
                          }}>
                            {confirmAdditionalCookingNotes}
                          </div>
                        ) : (
                          <div className="pe-2 flex-grow-1">
                            <input
                              type="text"
                              placeholder="Type additional notes"
                              maxLength={400}
                              value={additionalCookingNotes}
                              onChange={(e) => setAdditionalCookingNotes(e.target.value)}
                              className="addCookingnotesInput ff-poppins-medium fs-12 w-100"
                            />
                          </div>
                        )}

                        {additionalCookingNotes && (
                          <span
                            className="ff-poppins-semiBold fs-12 primary-text ms-2"
                            style={{ cursor: "pointer", whiteSpace: "nowrap" }}
                            onClick={() => {
                              setConfirmAdditionalCookingNotes(additionalCookingNotes);
                              setAdditionalCookingNotes('');
                              setShowAdditionalCookingNotes(false);
                            }}
                          >
                            Save
                          </span>
                        )}

                      </div>
                    </div>
                  }
                  {productDetail?.applied_card_detail?.card_type == "offer" || flow == "LoyaltyProduct" ?
                    <></> :
                    <>
                      <h6 className="ff-poppins-bold  fs-15 mt-3">Coupons</h6>
                      <div className="secondary-box mb-1  d-flex justify-content-between align-items-center rounded-3 h-100 p-1" onClick={() => navigate(`/Coupon_list/${vendorId}`, { state: { cart_id: cartId, fromPage: "product" } })}>
                        <div className="d-flex align-items-center  h-100">
                          <img src={apply_coupon} height="16px" width="20px" className="mt-1 ms-2" />

                          <span className="fs-14 ms-2 mt-1 ff-poppins-semiBold">
                            {
                              productDetail?.card_applied_status == 1 && productDetail?.applied_card_detail.card_type == "coupon" ?
                                productDetail.applied_card_detail.coupons_code : " Apply Coupon"
                            }
                          </span>
                          {
                            productDetail?.card_applied_status == 1 && productDetail?.applied_card_detail.card_type == "coupon" ?
                              <span className="fs-10 mt-1 rounded-4 text-center ms-2 ff-poppins-regular applied_lable">Applied</span> : ""
                          }

                        </div>

                        <div className="mt-2 mb-2 me-2 secondary-text-1  ff-poppins-regular fs-20">
                          <IoIosArrowForward />
                        </div>
                      </div>
                    </>
                  }

                  {/* Payment method  */}
                  {
                    flow != 'LoyaltyProduct' ?
                      <div className="mt-2">
                        <p className="ff-poppins-semiBold p-0 m-0 fs-16">Payment method</p>
                        {productDetail &&
                          productDetail.payment_options &&
                          productDetail.shipping_type ? (
                          <>
                            <div className="d-flex justify-content-between mt-1 mb-0" onClick={() => flowtype != "EDIT_ORDER" ? selectPaymentType(1) : ""} >
                              <div>
                                <p className="mb-0 fs-12 ff-poppins-semiBold"> Pay Full </p>
                                <p className="fs-10 ff-poppins-regular secondary-text">pay total amount now</p>
                              </div>
                              {selectpaytype == 1 ? (

                                <img src={tick_icon} height="20px" width="20px" />

                              ) : (
                                <MdOutlineRadioButtonUnchecked size={20} />
                              )}
                            </div>

                            {flowtype != "EDIT_ORDER" && productDetail.payment_options.advance_payment == '1' && shipingtype == "1" && (
                              <div
                                className="d-flex justify-content-between mb-0"
                                onClick={() => flowtype != "EDIT_ORDER" ? selectPaymentType(2) : null}
                              >
                                <div>
                                  <p className="mb-0 fs-12 ff-poppins-semiBold">Pay Advance</p>
                                  <p className="fs-10 ff-poppins-regular secondary-text">
                                    Pay a merchant-determined amount upfront now.
                                  </p>
                                </div>
                                {selectpaytype == 2 ? (
                                  <img src={tick_icon} height="20px" width="20px" />

                                ) : (
                                  <MdOutlineRadioButtonUnchecked size={20} />
                                )}
                              </div>
                            )}


                            {
                              flowtype != "EDIT_ORDER" && productDetail?.payment_options?.cash_after_delivery == '1' && shipingtype == "1" && (
                                <div className="d-flex justify-content-between mb-0" onClick={() => flowtype != "EDIT_ORDER" ? selectPaymentType(3) : ""}  >
                                  <div>
                                    <p className="mb-0 fs-12 ff-poppins-semiBold">
                                      Cash after product
                                    </p>
                                    <p className="fs-10 ff-poppins-regular secondary-text">
                                      Pay in cash after receiving the product.
                                    </p>
                                  </div>
                                  <div className="d-flex gap-2">
                                    {selectpaytype == 3 ? (
                                      <img src={tick_icon} height="20px" width="20px" />

                                    ) : (
                                      <MdOutlineRadioButtonUnchecked size={20} />
                                    )}
                                  </div>
                                </div>
                              )
                            }


                            {productDetail.payment_options.cash_after_service == 1 ? (
                              <div className="d-flex justify-content-between mb-0" onClick={() => { selectPaymentType(4); }}  >
                                <div>
                                  <p className="mb-0 fs-12  ff-poppins-semiBold">  Cash after service  </p>
                                  <p className="fs-10  ff-poppins-regular secondary-text">
                                    Pay in cash at the store after service completion.
                                  </p>
                                </div>
                                <div className="d-flex  gap-2">
                                  {selectpaytype == 4 ? (
                                    <img src={tick_icon} height="20px" width="20px" />
                                  ) : (
                                    <MdOutlineRadioButtonUnchecked size={20} />
                                  )}
                                </div>
                              </div>
                            ) : (
                              <></>
                            )}
                          </>
                        ) : (
                          <></>
                        )}
                      </div> : <></>
                  }
                  <div
                    className="d-flex justify-content-between align-items-center mt-2 h-100 cursor-pointer"
                    onClick={toggleContent}
                  >
                    <h6 className="bookInfoTextRP ff-poppins-semiBold mb-0">
                      Billing Information
                    </h6>

                    <span className="d-flex align-items-center">
                      {showContent ? (
                        <SlArrowUp size={16} />
                      ) : (
                        <SlArrowDown size={16} />
                      )}
                    </span>
                  </div>


                  <div>
                    {showContent && (
                      <div>
                        {productDetail?.booking_by_type_id == 2 ? (
                          // booked by the merchant's captain on the customer's behalf
                          <p className="ff-poppins-regular fs-13 p-0 m-0 mt-1">
                            Booking initiated at {productDetail?.booking_initiated_at} by {productDetail?.booking_merchant_name} ({productDetail?.booking_vendor_name}) for {productDetail?.user_details?.user_name}
                          </p>
                        ) : (
                          <p className="ff-poppins-regular fs-13 p-0 m-0 mt-1">Booking Initiated {initiateTime} by {productDetail?.user_details?.user_name}</p>
                        )}
                      </div>
                    )}
                    <hr className="my-2" />

                    {productDetail &&
                      productDetail?.card_applied_status == 1 &&
                      productDetail?.applied_card_detail?.card_type == "offer" &&
                      productDetail?.applied_card_detail?.offer_type == 3 ? (
                      <div className=" ">
                        <h6 className="fs-15 ff-poppins-semiBold primary-text"> Buy Products </h6>
                        {buyproduct.map((item, index) => {
                          return (
                            <div className="d-flex justify-content-between">
                              <p className="m-0 p-0 fs-12 ff-poppins-regular"> {item.product_name}</p>
                              <p className="m-0 p-0 fs-12 ff-poppins-regular"> {item.added_count} x {item.price}.00   </p>
                            </div>
                          );
                        })}
                        <div className="totalBar fs-13 m-0 success-text-dark d-flex justify-content-between p-1 mt-3 mb-2">
                          <p className="m-0 p-1 fs-12 ff-poppins-regular ">Total ( Offer Price )</p>
                          <p className="m-0 p-1 fs-12 ff-poppins-regular ">  Rs.{offerDetails.buy_products_total}  </p>
                        </div>
                        <h6 className="mt-2 fs-15 ff-poppins-semiBold p-0 primary-text mt-3"> Get Products </h6>
                        {getproduct.map((item, index) => {
                          return (
                            <div className="d-flex justify-content-between ff-poppins-regular ">
                              <span className="m-0 p-0 ff-poppins-regular fs-12"> {item.product_name}</span>
                              <span className="m-0 p-0 ff-poppins-regular fs-12"> {item.added_count} x {item.price}.00   </span>
                            </div>
                          );
                        })}
                        <div className="totalBar success-text-dark fs-13 m-0 d-flex justify-content-between p-1  mt-3 mb-2">
                          <span className="m-0 p-1 ff-poppins-regular fs-12 ">Total ( Free Value) </span>
                          <span className="m-0 p-1 ff-poppins-regular fs-12 ">  Rs.{offerDetails.get_products_total}  </span>
                        </div>
                      </div>
                    ) : (
                      <div className="servicePriceHeadDiv" style={{ paddingBottom: -10 }}   >
                        <h6 className="fs-15 ff-poppins-semiBold p-0">Products </h6>
                        <div>
                          {
                            productDetail?.pre_order_status == 1 ?
                              productDetail?.preorder_ticket?.products?.map((item, index) => (
                                <div key={index}>
                                  <div className="d-flex justify-content-between ff-poppins-regular fs-13">
                                    <p className="m-0">{item.product_name}</p>
                                    <div className="d-flex">
                                      {
                                        item?.added_addons_details &&
                                        <div onClick={() => toggleAddon(index)} style={{ cursor: 'pointer' }} >
                                          {showAddonsState[index] ? (<SlArrowUp className="me-2" />) : (<SlArrowDown className="me-2" />)}
                                        </div>}

                                      <p className="m-0 ms-2">
                                        1 x {item.price}
                                      </p>
                                    </div>

                                  </div>
                                  <div className="m-0 fs-12 col-10">
                                    {showAddonsState[index] ? (
                                      item?.added_addons_details?.map((addon, addonIndex) => (
                                        <div key={addonIndex} className="mt-1 d-flex justify-content-between ff-poppins-regular fs-12"  >
                                          <div> {addon.addon_name} - {addon.name}  </div>
                                          <div> {item.added_count} x {addon.price} </div>
                                        </div>
                                      ))
                                    ) : (
                                      <div className="ff-poppins-regular fs-12">
                                        {item?.added_addons_details?.map((addon) => addon?.name.trim()).join(', ')}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              ))
                              :
                              productDetail?.cart_products?.map((item, index) => (
                                <div key={index}>
                                  <div className="d-flex justify-content-between ff-poppins-regular fs-13">
                                    <p className="m-0">{item.product_name}</p>
                                    <div className="d-flex">

                                      {

                                        item?.added_addons_details != "" ?
                                          <div onClick={() => toggleAddon(index)} style={{ cursor: 'pointer' }} >
                                            {

                                              showAddonsState[index] ? (
                                                <SlArrowUp className="me-2" />
                                              ) : (
                                                <SlArrowDown className="me-2" />
                                              )
                                            }
                                          </div>
                                          : ""
                                      }

                                      <p className="m-0 ms-2">
                                        {item.added_count} x {(parseFloat(item.price) + parseFloat(item.addons_cost || 0)).toFixed(2)}
                                      </p>
                                    </div>

                                  </div>
                                  {/* <div className="mx-3 fs-12 col-10 ff-poppins-regular fs-12">
                                  {showAddonsState[index] ? (
                                    item?.added_addons_details?.map((addon, addonIndex) => (
                                      <div key={addonIndex} className="mt-1 d-flex justify-content-between "  >
                                        <div>
                                          {addon.addon_name} - {addon.name}
                                        </div>
                                        <div>
                                          {item.added_count} x {addon.price}
                                        </div>
                                      </div>
                                    ))

                                  ) : (
                                    <div className="ff-poppins-regular fs-12">
                                      {`( ${item?.added_addons_details.map((addon) => addon.name.trim()).join(', ')} )`}
                                    </div>
                                  )}
                                </div> */}


                                  <div className="ReviewPayAddonContainer">

                                    {showAddonsState[index] ?

                                      <>
                                        <div className="ReviewPayAddonList">
                                          <div className="ReviewPayAdddonName">{item.product_name}</div>
                                          <div className="ReviewPayAdddonPrice">1 x {item.price}</div>
                                        </div>
                                        {(
                                          item?.added_addons_details?.map((addon, addonIndex) => (
                                            <div className="ReviewPayAddonList" key={addonIndex}  >
                                              <div className="ReviewPayAdddonName">
                                                {addon.addon_name} - {addon.name}
                                              </div>
                                              <div className="ReviewPayAdddonPrice">
                                                {item.added_count} x {addon.price}
                                              </div>
                                            </div>
                                          )))}
                                      </>
                                      : (
                                        <div className="reviewPayAddonFull">
                                          {item?.added_addons_details?.length > 0
                                            ? `(${item?.added_addons_details.map((addon) => addon.name.trim()).join(", ")})`
                                            : ""}
                                        </div>

                                      )}

                                  </div>
                                </div>
                              ))

                          }
                        </div>
                        {productDetail && productDetail?.discount_status != "" ? (
                          <>
                            <div style={{ borderBottomColor: "gray", borderBottomWidth: 2, borderBottomStyle: "dashed", marginTop: 10, }} ></div>
                            <div className=" text-success fs-13 m-0 d-flex justify-content-between p-1 mt-1">
                              <p className="m-0 p-0 ff-poppins-medium fs-12">
                                {productDetail?.discount_detail?.lable} {" "}

                                {/* {'(' + (productDetail?.discount_status ?
                                productDetail.applied_card_detail?.discount_type == 2 && `${productDetail.applied_card_detail?.discount}%` : '') + ")"} */}
                              </p>
                              <p className="m-0 p-0 ff-poppins-medium fs-12"> Rs.{productDetail?.discount_detail?.discount_amount} </p>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    )}

                    {
                      productDetail?.card_applied_status == 1 &&
                      productDetail?.applied_card_detail?.card_type == "offer" &&
                      productDetail?.applied_card_detail?.offer_type == 4 &&
                      <div className="servicePriceHeadDiv  fs-13 m-0 d-flex justify-content-between p-1 mt-2 mb-2">
                        <span className="m-0 p-0 fs-12 ff-poppins-regular text-success mb-1">Subtotal(Offer Price)</span>
                        <span className="m-0 p-0 fs-12 ff-poppins-regular text-success mb-1"> Rs.{productDetail.applied_card_detail.offer_price}.00 </span>
                      </div>
                    }

                    <div className="servicePriceHeadDiv">
                      {
                        flow == 'LoyaltyProduct' ?
                          <div className="ff-poppins-regular fs-12" >
                            <div className="d-flex justify-content-between">
                              <p className="m-0 p-0">Subtotal</p>
                              <p className="m-0 p-0">{productDetail.sub_total} </p>
                            </div>
                            <div className="d-flex justify-content-between">
                              <p className="m-0 p-0">Pingle points redeemed ({loyaltyOfferDetails.offer_points})</p>
                              <p className="m-0 p-0"> - {productDetail.sub_total} </p>
                            </div>
                          </div>
                          :
                          <div className="ff-poppins-regular fs-12 ">
                            {productDetail?.applied_card_detail?.offer_type != 4 &&
                              <div className="d-flex justify-content-between">
                                <p className="m-0 p-0">Subtotal</p>
                                <p className="m-0 p-0">{productDetail.sub_total} </p>
                              </div>}
                            {
                              productDetail?.delivery_charges_status == true && (productDetail.delivery_type != 0 || productDetail.delivery_slot_status != 0) ?
                                <div className="d-flex justify-content-between">
                                  <p className="m-0 p-0">Delivery Charge</p>
                                  <p className="m-0 p-0">{productDetail.delivery_charges_amount} </p>
                                </div> : ""

                            }
                            {
                              deliverytipamt && deliverytipamt != 0 ?
                                <div className="d-flex justify-content-between ff-poppins-regular fs-12">
                                  <p className="m-0 p-0">Delivery Tip</p>
                                  <p className="m-0 p-0"> {Number(deliverytipamt)} </p>
                                </div> : ""
                            }
                            {
                              productDetail?.shipping_type != 0 && productDetail.total_packing_cost != 0 ?
                                <div className="d-flex  justify-content-between ff-poppins-regular fs-12">
                                  <p className="m-0 p-0">Packing cost</p>
                                  <p className="m-0 p-0">{productDetail.total_packing_cost} </p>
                                </div>
                                : ""
                            }


                            <div className="d-flex justify-content-between">
                              <p className="m-0 p-0">Platform Charges</p>
                              <p className="m-0 p-0">{productDetail.user_platform_charges}</p>
                            </div>
                          </div>
                      }

                      {flow != 'LoyaltyProduct' && gststatus == true ? (
                        <div className="ff-poppins-regular fs-12">
                          <div className="d-flex justify-content-between">
                            <p className="m-0 p-0 ">SGST</p>
                            <p className="m-0 p-0 ">{productDetail.total_sgst_amount}</p>
                          </div>
                          <div className="d-flex justify-content-between">
                            <p className="m-0 p-0">CGST</p>
                            <p className="m-0 p-0">{productDetail.total_cgst_amount}</p>
                          </div>
                        </div>
                      ) :
                        <></>
                      }

                      {flow != 'LoyaltyProduct' && productDetail.round_off != 0 ? (
                        <div className="d-flex justify-content-between ff-poppins-regular fs-12">
                          <p className="m-0 p-0">Round Off</p>
                          <p className="m-0 p-0">{productDetail.round_off}</p>
                        </div>
                      ) : (
                        <></>
                      )}



                    </div>

                    <div className="dashBorderRP"></div>

                    <div className="d-flex justify-content-end">
                      <div className="fs-14 mt-2 ff-poppins-bold w-100">
                        {flow == 'LoyaltyProduct' ? (
                          <div className="d-flex justify-content-between fs-14">
                            <span>Total</span>
                            <span className="text-end">Rs.0</span>
                          </div>
                        ) : (
                          <div className="w-100">
                            <div className="d-flex justify-content-between fs-14">
                              <span>Total</span>
                              <span className="text-end">Rs.{(Number(productDetail?.total_amount) + Number(deliverytipamt ? deliverytipamt : 0)).toFixed(2)}</span>
                            </div>
                            {productDetail?.edit_order_status == "1" && (
                              <div>
                                {productDetail?.edit_order_datails?.paid_amount &&
                                  <div className="d-flex  justify-content-between primary-text fs-14 mt-1 mb-1">
                                    <span>Paid</span>
                                    <span className="text-end">Rs.{productDetail?.edit_order_datails?.paid_amount}.00</span>
                                  </div>}

                                <div className="d-flex justify-content-between fs-14">
                                  <span className="me-1">To {productDetail?.edit_order_datails?.refund_status == 1 ? "Refund" : "Pay"} </span>
                                  {productDetail?.edit_order_datails?.paid_amount ?
                                    <span className="text-end">Rs.{Math.abs(productDetail?.total_amount - productDetail?.edit_order_datails?.paid_amount)}.00</span>
                                    :
                                    <span className="text-end">Rs.{productDetail?.total_amount}.00</span>

                                  }
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>

                    {selectpaytype == 2 ? (
                      <div className=" primary-text fs-14 ff-poppins-semiBold">
                        <p className="d-flex justify-content-between m-0 p-0"><span>Advance amount</span><span className="text-end">Rs.{productDetail?.payment_options?.advance_amount}</span></p>
                        <p className="d-flex justify-content-between m-0 p-0"><span>Balance amount</span><span className="text-end">Rs.{productDetail?.payment_options?.balence_amount}</span></p>
                      </div>
                    ) : (
                      <></>
                    )}

                    <div className="mt-2 ">
                      {
                        loyaltyOfferDetails.offer_id ?
                          <h6 className=" ff-poppins-medium  fs-10"><span className="fs-11 ff-poppins-medium primary-text">Note : </span> Loyalty points used for this redemption are non-refundable.</h6>
                          :
                          flow != "LoyaltyProduct" &&
                            (selectpaytype == 1 && productDetail?.payment_options?.refund_status == 1) || (selectpaytype == 2 && productDetail?.payment_options?.advance_refund_status == 1) ?
                            <h6 className=" ff-poppins-medium  fs-10"><span className="fs-11 ff-poppins-medium primary-text">Note :</span>  This booking may be cancelled with a refund subject to cancellation charges.</h6>
                            :
                            <h6 className=" ff-poppins-medium  fs-10"><span className="fs-11 ff-poppins-medium primary-text">Note :</span> This booking cannot be cancelled and are non-refundable once confirmed.</h6>
                      }
                    </div>
                  </div>
                </div>
              </div>

              <div className="product-paybtn-container ">
                <div className="offcanvas-body small">
                  {
                    errors.paybtn &&
                    <span className="inline-error-text ">
                      {errors.paybtn}
                    </span>
                  }
                  {userData?.user_type != "User" ?
                    <button className="product-paybtn" onClick={() => handleLoginNavigate()}>
                      Login &  {
                        selectpaytype == 3 ?
                          'Confirm Purchase' : ` Pay (${selectpaytype != 3 ? '₹' : ""}
                          ${selectpaytype == 2 ? productDetail?.payment_options?.advance_amount :
                            (Number(productDetail.total_amount) + Number(deliverytipamt)).toFixed(2)})`
                      }
                    </button>
                    :
                    <button className="product-paybtn" onClick={() => handleReviewAndPay()}>
                      {
                        isLoading ? (
                          <>
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"  ></span>
                            <span className="visually-hidden">Loading...</span>
                          </>
                        ) : (
                          flow == 'LoyaltyProduct' ? 'Redeem Now' :
                            selectpaytype == 3 || productDetail?.edit_order_datails?.refund_status == 1 ||
                              (productDetail?.edit_order_datails?.pay_status == 0 && productDetail?.edit_order_datails?.refund_status == 0) ?
                              'Confirm Purchase' :
                              <span>
                                Pay <span className="rupeeIcon">₹</span>
                                {selectpaytype == 2 ?
                                  (Number(productDetail?.payment_options?.advance_amount) + (Number(deliverytipamt) || 0)).toFixed(2) :
                                  productDetail?.edit_order_datails?.pay_status == 1 ? productDetail?.edit_order_datails?.balance_amount
                                    : (Number(productDetail.total_amount) + (Number(deliverytipamt) || 0)).toFixed(2)}
                              </span>

                        )
                      }
                    </button>}
                </div>
              </div>
            </div>
            {/* {deliverylocation.length == 0 ? (
              <div className="modal-backdrop fade show" onClick={closeLocationlistModal} style={{ zIndex: 1040 }}></div>
            ) : null} */}



            <div className={`offcanvas offcanvas-bottom Chooseaddres main }`}
              tabIndex="-1" id="selectLocatinModal" aria-labelledby="offcanvasBottomLabel"
              data-bs-backdrop="false" ref={locationModalRef} style={{ zIndex: 1045 }}>

              <div className="offcanvas-body small bg-light position-relative  d-flex flex-column gap-3">
                <div className="d-flex justify-content-between">
                  <div className="ff-poppins-semiBold"> Choose address </div>
                  <div onClick={() => closeLocationlistModal()}>
                    <CgCloseO />
                  </div>
                </div>

                <div className="d-flex flex-column gap-3 scroller-style-y">
                  {
                    userLocation.length > 0 ?
                      userLocation.map((location, index) => {
                        return (
                          <div onClick={() => location.select_status ? select_Location(location.latlng) :
                            toast(`Doorstep delivery available only ${" "} within ${productDetail.delivery_radius_distance}km`, { position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: "text-danger toast-style-1", })

                          } className="border-container px-2 py-2" >
                            <div className="d-flex align-items-center" style={{ opacity: location.select_status == 0 ? 0.4 : 1 }}  >
                              <div className="col-2">
                                <div className="border w-100 border-black border-opacity-10 rounded d-flex justify-content-center fs-24 primary-text py-2">
                                  {location.location_type_id == 1 ? (
                                    <IoMdHome className="primary-text" />
                                  ) : location.location_type_id == 2 ? (
                                    <MdWork className="primary-text" />
                                  ) : (
                                    <IoLocationSharp />
                                  )}
                                </div>
                              </div>
                              <div className="col-9">
                                <p className="m-0 ps-3 ff-poppins-bold">
                                  {location.location_type}{" "}
                                </p>
                                <p className="m-0 ps-3 ff-poppins-regular fs-12">
                                  {
                                    location.address.length > 30
                                      ? `${location.address.slice(0, 38)}...`
                                      : location.address
                                  }
                                  <span className="ms-2">  {location?.distance?.text} - {location?.duration?.text}</span>
                                </p>

                              </div>
                              <div className="col-1">
                                <IoIosArrowForward />
                              </div>
                            </div>
                          </div>
                        );
                      })
                      :
                      <div className="no-vendor-container">
                        <p className="ff-poppins-medium fs-14 ">No address saved</p>
                      </div>
                  }
                </div>

                <div onClick={() => { navigate("/AddDeliveryAddress", { state: { fromPage: 'products' } }); }} className="border-container px-2 py-2">
                  <div className="d-flex align-items-center">
                    <div className="col-2">
                      <div className="w-100  d-flex justify-content-center fs-24 primary-text py-2">
                        <FaRegSquarePlus />
                      </div>
                    </div>
                    <div className="col-9">
                      <p className="m-0 ps-3 ff-poppins-bold primary-text">Add New Address</p>
                    </div>
                  </div>
                </div>
              </div>

            </div>




            <div className="offcanvas offcanvas-bottom-modal" ref={deliveryOptionRef}>
              <div className="modal-container gap-3">
                <div>
                  <div className="d-flex justify-content-between align-items-center m-0 p-0">
                    <div >
                      <span className="p-0 m-0 ff-poppins-semiBold fs-14 text-dark">   Choose Delivery Options</span><br />
                      <span className="m-0 p-0 ff-poppins-medium  fs-12 secondary-text-2 ">Choose timeslot when order will be delivered</span>
                    </div>
                    <div className="p-0 m-0 fs-22 ff-poppins-semiBold" onClick={() => closeDeliveryoptionModal()} ><IoMdClose /></div>
                  </div>
                </div>
                <div className="custom-scroll d-flex flex-column gap-2">
                  <div >
                    <div className={`${productDetail?.delivery_settings?.slot_delivery_status == 2 ? 'opacity_Cls' : deliverytype == "slot" ? "primary-box primary-text" : "secondary-box"} rounded-3`}>
                      <div
                        className="d-flex justify-content-between align-items-center p-2 delivery-option-item"
                        onClick={() => {
                          if (productDetail?.delivery_settings?.slot_delivery_status === 2) {
                            showToast(productDetail?.delivery_settings?.slot_delivery_msg);
                            return;
                          }

                          setDeliverytype("slot");
                          closeDeliveryoptionModal();
                          openslotdeliveryModal();
                        }}
                      >
                        {/* LEFT SIDE */}
                        <div className="d-flex align-items-center">
                          <div className="ms-2">
                            <h6 className="fs-13 m-0 ff-poppins-semiBold">
                              Slot Delivery
                            </h6>
                            <p className="fs-10 m-0 ff-poppins-medium text-muted">
                              Delivered right on time, in your chosen slot!
                            </p>
                          </div>
                        </div>

                        <div className="d-flex align-items-center gap-2">
                          {productDetail?.delivery_settings?.slot_delivery_charge && (
                            <div className="fs-12 ff-poppins-semiBold mt-1">
                              <span className="rupeeIcon">₹</span>{productDetail?.delivery_settings?.slot_delivery_charge}
                            </div>
                          )}

                          <MdArrowForwardIos size={14} />
                        </div>
                      </div>
                    </div>
                    {
                      productDetail?.delivery_settings?.instant_delivery_status == "1" || productDetail?.delivery_settings?.own_instant_delivery_status == "1" ?
                        <div className={`${productDetail?.delivery_settings?.instant_delivery_status == 2 ? 'opacity_Cls' : deliverytype == "instant" ? "primary-box primary-text" : "secondary-box"} rounded-3 mt-2 mb-2`}>
                          <div className="d-flex justify-content-between align-items-center p-2" onClick={() => {
                            if (productDetail?.delivery_settings?.instant_delivery_status == 2) {
                              showToast(productDetail?.delivery_settings?.instant_delivery_msg)
                              return;
                            } else { setDeliverytype("instant") }
                          }}>
                            <div className="d-flex align-items-center">
                              {
                                deliverytype == "instant" ?
                                  <img src={select_circle} height="25px" width="25px" /> :
                                  <img src={unselect_circle} height="25px" width="25px" />
                              }
                              <div className="ms-3">
                                <h6 className="fs-13 p-0 m-0 ff-poppins-semiBold">Instant Delivery</h6>
                                <p className="fs-10 p-0 m-0 ff-poppins-regular ">Delivered to you in just 30 minutes!</p>
                              </div>
                            </div>
                            {productDetail?.delivery_settings?.instant_delivery_charge &&
                              <div className="fs-13 ff-poppins-semiBold">
                                <span className="rupeeIcon">₹</span>{productDetail?.delivery_settings?.instant_delivery_charge}
                              </div>
                            }
                          </div>
                        </div> : ""
                    }
                  </div>

                  <div className="d-flex flex-column gap-2">
                    <div className="d-flex justify-content-between" onClick={() => toggle_otherDelivery_option()}>
                      <h6 className="fs-14 p-0 m-0">Other options</h6>
                      <div>
                        {otherdeliveryoption ? (<SlArrowUp className="me-2" />) : (<SlArrowDown className="me-2" />)}
                      </div>
                    </div>

                    {otherdeliveryoption &&
                      <>
                        {/* <div className={`${deliverytype == "instore" ? "primary-box primary-text" : "secondary-box"} rounded-3`}>
                            <div className="d-flex  align-items-center gap-3 p-2" onClick={() => { setDeliverytype("instore") }}>
                              <div>
                                {
                                  deliverytype == "instore" ?
                                    <img src={select_circle} /> :
                                    <img src={unselect_circle} />
                                }
                              </div>
                              <div>
                                <h6 className="fs-13 p-0 m-0 ff-poppins-semiBold">In-store pickup</h6>
                                <p className="fs-11 p-0 m-0 ff-poppins-regular ">Hassle-free in-store pickup available !</p>
                              </div>
                            </div>
                          </div> */}
                        {productDetail?.delivery_settings?.courier_delivery != 0 &&
                          <div className={`${deliverytype == "courier" ? "primary-box primary-text" : "secondary-box"} ${productDetail?.delivery_settings?.courier_delivery == 2 ? "opacity-40" : ""} rounded-3`}>
                            <div className="d-flex justify-content-between  align-items-center gap-3 p-2" onClick={() => {
                              if (productDetail?.delivery_settings?.courier_delivery == 2) {
                                toast(`${productDetail?.delivery_settings?.courier_msg}..`, { position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: "text-danger toast-style-1", });
                              }
                              else {
                                getAvailableCourierList()
                              }
                            }}>
                              <div>
                                <h6 className="fs-13 p-0 m-0 ff-poppins-semiBold">Courier Delivery</h6>
                                <p className="fs-11 p-0 m-0 ff-poppins-regular ">secure and swift Courier delivery!</p>
                              </div>
                              <div className="d-flex justify-content-end ">
                                <div>
                                  <MdArrowForwardIos />
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                      </>
                    }
                  </div>
                </div>
                <div>
                  <button className={`primary-bottom-btn  rounded-3 fs-14 ff-poppins-medium`}
                    onClick={() => {
                      if (deliverytype == "") {
                        showToast("Please select a delivery type")
                      }
                      else if (deliverytype == "instant") {
                        if (productDetail?.delivery_settings?.instant_delivery_status == 2) {
                          toast(`${productDetail?.delivery_settings?.instant_delivery_msg}..`, { position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: "text-danger toast-style-1", });
                        }
                        else {
                          Select_Delivery_Slot("INSTANT");
                          setInstantDelivery(true)
                        }
                      } else if (deliverytype == "instore") {
                        closeLocationlistModal()
                        closeLocationModal()
                        updateInstore(1)
                      }
                      else if (deliverytype == "doorstep") {
                        updateInstore(2)
                      }
                      else if (deliverytype == "courier") { }
                    }} >
                    Continue
                  </button>
                </div>
              </div>
            </div>

            <div className="offcanvas offcanvas-bottomm Choose_delivery_options main  top_border_radius" ref={courierModelRef}
              style={{ position: "fixed", zIndex: 1045, left: "50%", transform: "translateX(-50%)", width: "390px", height: 'max-content' }}  >
              <div className="p-2">
                <div className="mb-2">
                  <div className="d-flex justify-content-between">
                    <p className="fs-12 p-0 m-0 ff-poppins-medium ">Courier Delivery</p>
                    <div className="fs-18" onClick={() => closecourierlistModal()}>
                      <IoMdClose />
                    </div>
                  </div>
                  <p className="fs-10 ff-poppins-regular p-0 m-0 ">Choose your preferred  courier delivery</p>
                </div>
                <div className="customScroll gap-2 scroller-style-y" >
                  {
                    availableCourierList?.map((list, index) => {
                      return (
                        <div className={`${selectedCourierDelivery?.id == list.id ? "primary-box primary-text" : "secondary-box"} rounded-3`}>
                          {
                            list.courier_company_id == recomendedCourier.recommended_courier_company_id &&
                            < div className="d-flex justify-content-end p-0 m-0 me-1">
                              <p className="ff-poppins-medium fs-10 p-0 m-0">Recommended</p>
                            </div>
                          }
                          <div className="d-flex justify-content-between align-items-center p-2" onClick={() => { setSelectedCourierDelivery(list) }}>
                            <div className="d-flex align-items-center">
                              {
                                selectedCourierDelivery?.id == list.id ?
                                  <img src={select_circle} height="25px" width="25px" /> :
                                  <img src={unselect_circle} height="25px" width="25px" />
                              }
                              <div className="ms-3">
                                <h6 className="fs-12 p-0 m-0 ff-poppins-semiBold">{list.courier_name}</h6>
                                <p className="fs-11 p-0 m-0 ff-poppins-regular ">ETA : {list.etd}</p>
                              </div>
                            </div>
                            <div className=" ff-poppins-semiBold fs-12">
                              <span className="rupeeIcon">₹</span>{list.freight_charge}
                            </div>
                          </div>
                        </div>
                      )
                    })
                  }
                </div>
                <div>
                  <div className={` primary-bottom-btn text-center rounded-3 fs-14 ff-poppins-medium`}
                    onClick={() => {
                      if (selectedCourierDelivery?.id) {
                        selectCourierDelivery(selectedCourierDelivery?.courier_company_id)
                      } else { showToast('Please select a courier service') }
                    }}>
                    Continue
                  </div>
                </div>
              </div>
            </div>

            <div className="offcanvas offcanvas-bottom-modal" ref={slotdeliveryModalRef}  >
              <div className=" ">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="p-0 m-0 fs-13 ff-poppins-semiBold text-dark" onClick={() => { handleModalBack() }}>
                    <span className=" " >
                      <IoChevronBack size={18} color="balck" className="me-1" />
                    </span>
                    <span >
                      Back
                    </span>
                  </div>
                  <span className="p-0 m-0 fs-20 ff-poppins-semiBold" onClick={() => closeslotdeliveryModal()} ><IoMdClose /></span>
                </div>

                <div className="p-1">
                  <div className="mb-2">
                    <p className="ff-poppins-medium fs-14  text-dark p-0 m-0">Slot Delivery </p>
                    <p className="ff-poppins-medium fs-12 secondary-text-2 p-0 m-0">Choose timeslot when order will be delivered</p>
                  </div>
                  <div className="d-flex flex-column ">
                    <div className={`${deliverytype == "any" ? "primary-box primary-text" : "secondary-box"} rounded-3`}>
                      <div className="d-flex justify-content-between align-items-center p-2" onClick={() => { setDeliverytype("any"); }}>
                        <div className="d-flex align-items-center">
                          {
                            deliverytype == "any" ?
                              <img src={select_circle} height="25px" width="25px" /> :
                              <img src={unselect_circle} height="25px" width="25px" />
                          }
                          <div className="ms-3">
                            <h6 className="fs-13 p-0 m-0 ff-poppins-semiBold"  >Any time</h6>
                            <p className="fs-10 p-0 m-0 ff-poppins-regular ">Delivered anytime,once sent by the merchant!</p>
                          </div>
                        </div>
                        {productDetail?.delivery_settings?.slot_delivery_charge &&
                          <div className="fs-13 ff-poppins-semiBold">
                            <span className="rupeeIcon">₹</span>{productDetail?.delivery_settings?.slot_delivery_charge}
                          </div>}
                      </div>
                    </div>


                    <div className={`${deliverytype == "timeslot" ? "primary-box primary-text" : "secondary-box"} rounded-3 mt-2`}>
                      <div className="d-flex justify-content-between align-items-center p-2" onClick={() => { setDeliverytype("timeslot"); }} >
                        <div className="d-flex align-items-center">
                          {
                            deliverytype == "timeslot" ?
                              <img src={select_circle} height="25px" width="25px" /> :
                              <img src={unselect_circle} height="25px" width="25px" />
                          }
                          <div className="ms-3">
                            <h6 className="fs-13 p-0 m-0 ff-poppins-semiBold">Choose time slot</h6>
                            <p className="fs-10 p-0 m-0 ff-poppins-regular ">Delivered right on time,in your chosen slot!</p>
                          </div>
                        </div>
                        {productDetail?.delivery_settings?.slot_delivery_charge &&
                          <div className="fs-13 ff-poppins-semiBold">
                            <span className="rupeeIcon">₹</span>{productDetail?.delivery_settings?.slot_delivery_charge}
                          </div>}
                      </div>
                    </div>

                  </div>
                </div>
                <div className={`primary-bottom-btn rounded-3 mt-1 fs-14 ff-poppins-regular text-center mt-2`}
                  onClick={() => {
                    if (deliverytype == "any") {
                      Select_Delivery_Slot("ANY");
                    } else if (deliveryModelStatus == false) {
                      handelSelectTime();
                      setDeliverytype("timeslot");
                    }
                  }}>
                  Continue
                </div>
              </div>
            </div>



            {
              showInstructionModal &&
              <div >
                <InstructionsNoteModal toggleshowInstruction={toggleshowInstruction} />
              </div>

            }


            {/* {
              userData?.user_type != "Guest" && check ?
                addonModel == false ?
                  (shipingtype == "2" && productDetail.delivery_location_status == true && (productDetail?.delivery_slot_type == '2' || 
                  productDetail?.delivery_slot_status != '0'))
                    ||
                    shipingtype != 2 || flow == 'LoyaltyProduct' || productDetail.delivery_type == 2 ? (
                    <div className="forgetRadiusDivRP bg-white" style={{ position: 'sticky', bottom: 0, padding: 10, }}  >
                      <div className=" ">
                        <button
                          style={{ borderRadius: "6px", margin: "15px 0px" }}
                          className={`primary-bg reviewAndPayBtnProduct ff-balooPaaji2-bold`}
                          onClick={() => { userData?.user_type == "Guest" ? handleLoginNavigate() : handleReviewAndPay(); }}
                        >
                          {
                            userData?.user_type == "Guest" ? "Login and pay" :
                              isLoading ? (
                                <>
                                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"  ></span>
                                  <span className="visually-hidden">Loading...</span>
                                </>
                              ) : (
                                flow == 'LoyaltyProduct' ?
                                  'Redeem Now' :
                                  selectpaytype == 3 || productDetail.edit_order_datails.refund_status == 1 ||
                                    (productDetail.edit_order_datails.pay_status == 0 && productDetail.edit_order_datails.refund_status == 0) ?
                                    'Confirm Purchase' :
                                    ` Pay ₹${selectpaytype == 2 ?
                                      (Number(productDetail?.payment_options?.advance_amount) + (Number(deliverytipamt) || 0)).toFixed(2) :
                                      productDetail.edit_order_datails.pay_status == 1 ? productDetail.edit_order_datails.balance_amount
                                        : (Number(productDetail.total_amount) + (Number(deliverytipamt) || 0)).toFixed(2)
                                    }`


                              )}
                        </button>
                      </div>
                    </div>
                  ) : (
                    ""
                  )
                  : ""
                :
                <div className="forgetRadiusDivRP bg-white" style={{ position: 'sticky', bottom: 0, padding: 10, }}  >
                  <div className=" ">
                    <button style={{ borderRadius: "6px", margin: "15px 0px" }}
                      className={`primary-bg reviewAndPayBtnProduct ff-balooPaaji2-bold`} onClick={() => handleLoginNavigate()}   >
                      Login &   {
                        selectpaytype == 3 ?
                          'Confirm Purchase' :
                          ` Pay (${selectpaytype != 3 ? '₹' : ""}
                          ${selectpaytype == 2 ? productDetail?.payment_options?.advance_amount : (Number(productDetail.total_amount) + Number(deliverytipamt)).toFixed(2)})`
                      }
                    </button>

                  </div>
                </div>
            } */}



            {showDatePickerModal && (
              <DeliveryTime_Slot
                isOpen={isDatePickerOffCanvasOpen}
                toggleOffCanvas={toggleDatePickerOffCanvas}
                vendorId={vendorId}
                shipingtype={shipingtype}
              />
            )}

            {/* {showDatePickerModal && <div className="modal-backdrop fade show"></div>} */}


          </div >
          :
          <div className="skeleton-bg">

            <Skeleton height={80} borderRadius={12} style={{ marginBottom: '10px' }} />
            <Skeleton height={80} borderRadius={12} style={{ marginBottom: '10px' }} />
            <Skeleton height={80} borderRadius={12} style={{ marginBottom: '10px' }} />
            <Skeleton height={80} borderRadius={12} style={{ marginBottom: '10px' }} />
            <Skeleton height={80} borderRadius={12} style={{ marginBottom: '10px' }} />
            <Skeleton height={80} borderRadius={12} style={{ marginBottom: '10px' }} />

          </div>
      }

      {
        modalOpen &&
        // <div className="modal fade show successModal" style={{ display: 'block' }} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-modal="true">

        //   <div class="modal-dialog modal-dialog-centered mainModal ">
        //     <div class="modal-content p-3">
        //       <div class="modal-body text-center ff-balooPaaji2-bold mb-3">
        //         <h5>Delete Product</h5>
        //         Are you sure want to delete the product ?
        //         <div className="d-flex justify-content-around mt-2">
        //           <button type="button" class="btn btn-secondary ff-balooPaaji2-bold" onClick={() => closedelectorderModal()} > Cancel </button>
        //           <button type="button" class="btn btn-danger ff-balooPaaji2-bold" data-bs-dismiss="modal" onClick={() => deleteProduct()} >
        //             Delete
        //           </button>
        //         </div>
        //       </div>
        //       <div class="modal Footer"></div>
        //     </div>
        //   </div>
        // </div>

        <>
          <div className="modal-backdrop fade show"></div>
          <div className="modal fade show successModal" style={{ display: 'block' }} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-modal="true">
            <div className="modal-dialog modal-dialog-centered modal-sm m-0" style={{ maxWidth: "360px" }}>
              <div className="modal-content rounded-3">
                <div className="modal-body p-4">
                  <div className='text-center ff-poppins-semiBold fs-14 '>Are you sure want to delete the product?</div>
                  <div className="d-flex text-center justify-content-between mt-3">
                    <div className="logout-modal-btn text-light primary-bg" onClick={() => deleteProduct()}>Yes</div>
                    <div className="logout-modal-btn primary-text primary-bg-light  ms-3" onClick={() => closedelectorderModal()}>No</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      }

      <div className="modal fade " aria-labelledby="exampleModalLabel" aria-hidden="true" ref={paymentSuccessModalRef} style={{ backgroundColor: "#ebebeb", zIndex: "6666" }}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content modal-success ff-poppins-semiBold rounded-4" style={{ width: '80%' }}>
            <div className="  d-flex justify-content-center align-items-center">
              <Lottie animationData={SuccessLotie} loop={1} autoPlay={true} />
            </div>
            <div className="mt-1 text-center fw-bold primary-text">
              Payment Success.
            </div>
            <div className="text-center mb-3">
              <div className="  fw-bold">
                Redirecting you to your ticket.
              </div>
              <button type="button" className="lottieOkBtn rounded-pill" onClick={() => handleOkClick("normal")}>
                OK
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className={`modal fade`} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" ref={orderSuccessModalRef} style={{ backgroundColor: "#ebebeb" }} >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content modal-success" style={{ width: "80%" }} >

            <div className="lottieModelImg">
              <Lottie animationData={SuccessLotie} loop={1} autoPlay={true} />
            </div>
            {
              flow == 'LoyaltyProduct' ?
                <div className="text-center ff-poppins-semiBold primary-text fs-14 ">

                  Offer Redeemed!
                </div>
                :
                <div className="ff-poppins-semiBold fs-14 ">
                  <div className="text-center primary-text">
                    Order Successful.
                  </div>
                  <div className="text-center fw-bold">
                    Redirecting you to your ticket.
                  </div>
                </div>

            }

            <div className="text-center mb-2 mt-1">
              <button type="button" className="lottieOkBtn rounded-pill" onClick={() => handleOkClick("loyalty&cashafter")} >
                OK
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className={`modal fade`} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" ref={cancelOrderModalRef} style={{ zIndex: "9999", backgroundColor: "rgb(210 210 210)" }}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content modal-success" style={{ width: "60%" }} >
            <div className="modal-header">
              <div className="text-center ff-poppins-regular fs-12">Are you sure you want to cancel the order</div>
            </div>
            <div className="d-flex justify-content-around  mt-3 mb-2">
              <button type="button" className="btn btn-secondary" onClick={() => closecancelOrderModal()}>Cancel</button>
              <button type="button" className="btn btn-danger" onClick={() => cancelConfirmedOrder()}>Confirm</button>
            </div>

          </div>
        </div>
      </div>
      {/* <div className={`modal fade`} ref={cancelOrderModalRef}  tabIndex="-1" aria-labelledby="exampleModalLabel" aria-modal="true">
        <div class="modal-dialog modal-dialog-centered"  >
          <div className="modal-body ps-5 pe-5 pt-4 pb-4">
            <div className="text-center ff-poppins-semiBold fs-16 mb-3">Delete account</div>  </div>
        </div>
      </div> */}
      {isModalOpen && <div className="modal-backdrop fade show"></div>}

      {showInstructionModal && <div className="modal-backdrop fade show"></div>}


    </>
  );
};

export default ReviewPay;

